<template>
  <div class='approvalDetail' style='position: relative;'>
    <a-spin :spinning='loading'>
      <!--  客户影像资料    -->
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'customerImageInfo')"
        type='inner'
        v-viewer='viewOptions'>
        <div v-for='(item, index) in imageInfos' :key='item.imgType'>
          <div class='file-box'>
            <div class='file-item'>
              <p class='file-label'>{{ FILE_TYPE[item.imgType] }}</p>
              <img class='file-preview' :src='item.imgUrl' preview='0'>
            </div>
          </div>
        </div>
      </a-card>
      <!--  订单信息-->
      <a-card
        :title="$t(I18N_KEY.ORDER + 'orderInfo')"
        type='inner'
        style='margin-top: 24px;'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'productName')">{{ orderInfo.productName }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'applyAmt')">{{ orderInfo.applyAmt }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'submissionTime')">{{ orderInfo.submitTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'applicationDeadline')">{{ orderInfo.applyDuration }}
          </detail-list-item>

          <detail-list-item :term="$t(I18N_KEY.ORDER + 'orderNo')">{{ orderInfo.orderNo }}</detail-list-item>
          <detail-list-item v-if="languageStorage=='zh-CN'" :term="$t(I18N_KEY.ORDER + 'orderType')">
            {{ $t(ORDER_TYPE_CN[orderInfo.orderType]) }}
          </detail-list-item>
          <detail-list-item v-if="languageStorage=='en-US'" :term="$t(I18N_KEY.ORDER + 'orderType')">
            {{ $t(ORDER_TYPE_EN[orderInfo.orderType]) }}
          </detail-list-item>
          <detail-list-item v-if="languageStorage=='ti'" :term="$t(I18N_KEY.ORDER + 'orderType')">
            {{ $t(ORDER_TYPE_TI[orderInfo.orderType]) }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'paymentAmt')">{{ orderInfo.paymentAmt }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'paymentTime')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.paymentTime }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'extendAmoumt')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.extendAmoumt }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'repaymentAmount')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.repaymentAmount }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'settleAmt')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.settleAmt }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'lateFee')">{{ orderInfo.lateFee }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'overdueDayC')">{{ orderInfo.overdueDays }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'OrdersubmissionTime')">{{ orderInfo.submitTime }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'payoutId')">{{ orderInfo.payoutId }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankName')">
            {{ bankCardInfo.bankName }}
<!--            <Dict :dict-code='DICT_CODE.BANKLISTF' :value='bankCardInfo.bankAccountName' />-->
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountNo')">{{ bankCardInfo.bankAccountNo }}
          </detail-list-item>
        </detail-list>
      </a-card>
      <!--审核客户信息-->
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'customerBasicInfo')"
        type='inner'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'names')">
            {{ basicInfo.names }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'ThaiName')">{{ basicInfo.surnames }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'ThaibmName')">{{ basicInfo.aliasName }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'curp')">{{ basicInfo.curp }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'birthdayValue')">{{ basicInfo.birthday }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'shouru')">
            <Dict :dict-code="DICT_CODE.MONTHLY_INCOME" :value="detailInfo.monthlyIncomeScope"/>
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'educalevel')">
<!--            {{ detailInfo.education }}-->
            <Dict :dict-code="DICT_CODE.EDUCATION" :value="detailInfo.education"/>
          </detail-list-item>

          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'childNum')">{{ detailInfo.numberOfChildren }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'marryState')">
            <Dict :dict-code="DICT_CODE.MARITAL_STATUS" :value="detailInfo.maritalStatus"/>
          </detail-list-item>


          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountNo')">{{ bankCardInfo.bankAccountNo }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'collectType')">{{ COLLECT_TYPE[bankCardInfo.collectType] }}
          </detail-list-item>

          <detail-list-item v-if="languageStorage=='zh-CN'" :term="$t(I18N_KEY.CUSTOMER + 'reborrowFlag')">
            {{ REBORROW_FLAG[basicInfo.reborrowFlag] }}
          </detail-list-item>
          <detail-list-item v-if="languageStorage=='en-US'" :term="$t(I18N_KEY.CUSTOMER + 'reborrowFlag')">
            {{ REBORROW_FLAG_EN[basicInfo.reborrowFlag] }}
          </detail-list-item>
          <detail-list-item v-if="languageStorage=='ti'" :term="$t(I18N_KEY.CUSTOMER + 'reborrowFlag')">
            {{ REBORROW_FLAG_TI[basicInfo.reborrowFlag] }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'channel')">{{ basicInfo.channel }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'createTime')">{{ basicInfo.createdTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'fb')">
            <div style='display: flex;justify-content: flex-start;flex-direction: row'>
              <div v-if='showFBInput'>
                <a-input v-model='FBvalue' />
              </div>
              <div v-else>
                <a :href='"https://www.facebook.com/"+detailInfo.fb' target='_blank'>
                  {{ detailInfo.fb }}
                </a>
              </div>
              <a-button v-if='showFBInput' @click='saveFBEdit' type='primary'
                        style='margin-left: 20px'>
                {{ $t(I18N_KEY.ORDER + 'saveEdit') }}
              </a-button>

              <a-button v-if='showFBInput' @click='cancelSaveFBEdit' type='primary'
                        style='margin-left: 20px'>
                {{ $t(I18N_KEY.ORDER + 'cancelSaveEdit') }}
              </a-button>

              <a-button v-if='btndisableFBValue' @click='editFBEmail(detailInfo.fb,detailInfo.custInfoId)'
                        type='primary'
                        style='margin-left: 20px'> {{ $t(I18N_KEY.ORDER + 'EditValue') }}
              </a-button>
            </div>
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'creatEmail')">
            <div style='display: flex;justify-content: flex-start;flex-direction: row'>
              <div v-if='showEmialInput'>
                <a-input v-model='emailvalue' />
              </div>
              <div v-else>
                {{ basicInfo.email }}
              </div>
              <a-button v-if='showEmialInput' @click='saveEdit' type='primary'
                        style='margin-left: 20px'>
                {{ $t(I18N_KEY.ORDER + 'saveEdit') }}
              </a-button>

              <a-button v-if='showEmialInput' @click='cancelSaveEdit' type='primary'
                        style='margin-left: 20px'>
                {{ $t(I18N_KEY.ORDER + 'cancelSaveEdit') }}
              </a-button>

              <a-button v-if='btndisableEmailValue' @click='editEmail(basicInfo.email,basicInfo.id)'
                        type='primary'
                        style='margin-left: 20px'> {{ $t(I18N_KEY.ORDER + 'EditValue') }}
              </a-button>
              <!--       发送邮件        -->
              <!--              <a-button @click='sendEmail(basicInfo.email,basicInfo.id)' type='primary'-->
              <!--                        style='margin-left: 20px'> {{ $t(I18N_KEY.ORDER + 'senfEmail') }}-->
              <!--              </a-button>-->
            </div>
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'RegisPhoneNum')">
            <!-- 审核通过全部号码展示 -->
            <div v-if='checkedpass'>
              <a href="javascript:void(0)"
                 @click="handlePhoneClick(basicInfo.mobileNo)">
                <!--                {{ basicInfo.mobileNoASE }}</a>-->
                {{ basicInfo.mobileNo }}</a>
            </div>
            <div style='display: flex;flex-direction: row'>
              <div style='display: flex' v-if='btndisableValue && showmyself'>
                <a href="javascript:void(0)"
                   @click="handlePhoneClick(basicInfo.mobileNo)">
                  <!--                {{ basicInfo.mobileNoASE }}</a>-->
                  {{ basicInfo.mobileNo }}
                </a>
                <!--               <a-button v-if='btndisableValue && showmyself'-->
                <!--                         @click='openRemarkModal("本人",basicInfo.names,basicInfo.mobileNo,recentcontactNum+1)'-->
                <!--                         style='margin-left: 30px'-->
                <!--                         type='primary'> {{ $t('remark') }}-->
                <!--               </a-button>-->
                <a-button

                  @click='openRemarkModal("本人",basicInfo.names,basicInfo.mobileNo,recentcontactNum+1)'
                  style='margin-left: 30px'
                  type='primary'> {{ $t('remark') }}
                </a-button>
                <div style='margin-left: 20px' v-if='showzhudedianhua'><img style='width: 28px'
                                                                            src='../../../assets/finish.png'>
                </div>
              </div>
            </div>
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'line')">
            <div style='display: flex;justify-content: flex-start;flex-direction: row'>
              <div v-if='showLineInput'>
                <a-input v-model='linevalue' />
              </div>
              <div v-else style='color: #1890ff'>
                  {{ detailInfo.line }}
              </div>
              <a-button v-if='showLineInput' @click='saveLineEdit' type='primary'
                        style='margin-left: 20px'>
                {{ $t(I18N_KEY.ORDER + 'saveEdit') }}
              </a-button>

              <a-button v-if='showLineInput' @click='cancelSaveLineEdit' type='primary'
                        style='margin-left: 20px'>
                {{ $t(I18N_KEY.ORDER + 'cancelSaveEdit') }}
              </a-button>

              <a-button v-if='btndisablelineValue' @click='editLineNumber(detailInfo.line,detailInfo.custInfoId)'
                        type='primary'
                        style='margin-left: 20px'> {{ $t(I18N_KEY.ORDER + 'EditValue') }}
              </a-button>
            </div>
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'tiktokNumber')">
            <div style='display: flex;justify-content: flex-start;flex-direction: row'>
              <div v-if='showtiktokInput'>
                <a-input v-model='tiktokvalue' />
              </div>
              <div v-else style='color: #1890ff'>
                {{ detailInfo.tiktokNumber }}
              </div>
              <a-button v-if='showtiktokInput' @click='savetiktokEdit' type='primary'
                        style='margin-left: 20px'>
                {{ $t(I18N_KEY.ORDER + 'saveEdit') }}
              </a-button>

              <a-button v-if='showtiktokInput' @click='cancelSavetiktokEdit' type='primary'
                        style='margin-left: 20px'>
                {{ $t(I18N_KEY.ORDER + 'cancelSaveEdit') }}
              </a-button>

              <a-button v-if='btndisabletiktokValue' @click='edittiktokNumber(detailInfo.tiktokNumber,detailInfo.custInfoId)'
                        type='primary'
                        style='margin-left: 20px'> {{ $t(I18N_KEY.ORDER + 'EditValue') }}
              </a-button>
            </div>
          </detail-list-item>

          <detail-list-item :term="$t(I18N_KEY.ORDER + 'Currentaddress')">{{ detailInfo.residentialAddress }}</detail-list-item>
          <detail-list-item v-if='!showForm' :term="$t(I18N_KEY.HumanReviewDataSet + 'isinsatll')">
            <div style='height: fit-content !important;display: flex;
          justify-content: flex-start;align-items: center; margin-bottom: 20px'>
              <p style='margin: 0 20px !important;color: #1890FF;' v-if='creditappsNum>0'>
                {{ $t(I18N_KEY.HumanReviewDataSet + 'isinsatllyes') }}
                {{ $t(I18N_KEY.HumanReviewDataSet + 'insatllpartone') }} {{creditappsNum}}
                {{ $t(I18N_KEY.HumanReviewDataSet + 'insatllparttwo') }}
              </p>
              <p style='margin: 0 20px !important;color: #1890FF;' v-else>
                {{ $t(I18N_KEY.HumanReviewDataSet + 'isinsatllno') }}
              </p>
              <a-button type='primary' @click='getCreditAppData(basicInfo.mobileNo)'>
                {{ $t(I18N_KEY.HumanReviewDataSet + 'refresh') }}
              </a-button>

            </div>
          </detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'witnessScore')">{{ detailInfo.witnessScore }}
            <a-button
              @click='sendtipsmsg'
              style='margin-left: 30px'
              type='primary'>{{ $t(I18N_KEY.ORDER + 'sendtipsmsg') }}
            </a-button>
          </detail-list-item>
        </detail-list>

      </a-card>
      <!--      <a-card-->
      <!--        :title="$t(I18N_KEY.ORDER + 'examineCustomerInfo')"-->
      <!--        type='inner'-->
      <!--        style='margin-top: 24px;'>-->
      <!--        <detail-list>-->
      <!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'mobile')">{{ basicInfo.mobileNo }}</detail-list-item>-->
      <!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'age')">{{ basicInfo.age }}</detail-list-item>-->
      <!--          <detail-list-item :term="$t('birthday')">{{ basicInfo.birthday }}</detail-list-item>-->
      <!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'AadhaarName')">{{ basicInfo.aadhaarName }}</detail-list-item>-->
      <!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'panName')">{{ basicInfo.panName }}</detail-list-item>-->
      <!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountName')">{{ basicInfo.panName }}</detail-list-item>-->
      <!--          &lt;!&ndash;<detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'epochScore')">{{ basicInfo.epochScore }}</detail-list-item>&ndash;&gt;-->
      <!--          &lt;!&ndash;<detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'modelScore')">{{ basicInfo.modelScore }}</detail-list-item>&ndash;&gt;-->
      <!--          <detail-list-item :term="$t(I18N_KEY.ORDER + 'sxCreditScore')">{{ orderInfo.sxCreditScore }}-->
      <!--          </detail-list-item>-->
      <!--          <detail-list-item :term="$t(I18N_KEY.ORDER + 'sxCheatScore')">{{ orderInfo.sxCheatSccore }}</detail-list-item>-->
      <!--        </detail-list>-->
      <!--      </a-card>-->
      <!--  客户联系人信息-->
      <!-- 添加客户联系人信息按钮 -->
      <a-button v-if='showForm' style='margin-top: 30px;' @click='addcustomerLinkInfoFun' type='primary'>
        {{ $t(I18N_KEY.CUSTOMER + 'addcustomerLinkInfo') }}
      </a-button>
      <a-card
        style='margin-top: 24px ;'
        :title="$t(I18N_KEY.CUSTOMER + 'customerLinkInfo')"
        type='inner'>
        <a-table
          :columns='linkColumns'
          :dataSource='linkmanInfos'
          :pagination='false'
          bordered
          ref='table'
          size='middle'
          :rowKey='(record) => record.index'>
          <template slot='contactName' slot-scope='text, record,index'>
            <span v-if="record.contactName!=''||index!= linkmanInfos.length-1">{{ record.contactName }}</span>
            <a-input v-else v-model='addcontactName' @change='contactNameChange' />
          </template>
          <template slot='contactPhonteValue' slot-scope='text, record,index'>
            <div
              style='display: flex;flex-direction: row;align-items: center;justify-content: center;'>
              <div style='width:400px;display: flex'>
                <!--      联系人手机号不为空的情况      -->
                <div v-if='record.contactPhone!==""' style='display: flex'>
                  <div v-if='checkedpass'>
                    <a  href="javascript:void(0)"
                       @click="handlePhoneClick( record.contactPhone)">
                      {{ record.contactPhone
                      }}</a>
                  </div>
                  <div style='display: flex;'
                       v-if='btndisableValue && (isShowContacts || record.isManualAddContact==1)'>
                    <div>
                      <a  href="javascript:void(0)"
                         @click="handlePhoneClick(record.contactPhone)">
                        {{ record.contactPhone
                        }}</a>
                    </div>
                    <div
                      style='display: flex'>
                      <div
                        style='margin-left: 20px;'>
                        <a-button type='primary'

                                  @click='openRemarkModal(record.contactType,record.contactName,record.contactPhone,index)'>
                          {{ $t('remark') }}
                        </a-button>

                      </div>

                      <div>
                        <img v-if="record.backup!=''"
                             style='width: 28px;margin-left: 20px'
                             src='../../../assets/finish.png'>
                      </div>
                    </div>
                  </div>
                </div>
                <!--         添加联系人 输入联系人号码       -->
                <div v-else style='display: flex'>
                  <a-input v-model='addcontactPhoneNum' type='number' @change='addcontactPhoneNumChange'></a-input>
                  <a-button @click='addcontactNameSubmit' style='margin-left: 20px' type='primary'>{{ $t('add') }}
                  </a-button>
                </div>
              </div>
            </div>
          </template>
          <template v-if="languageStorage=='ti' || languageStorage=='zh-CN' || languageStorage=='en-US'"
                    slot='contactType' slot-scope='text, record'>
            <div v-if="record.contactType===$t(I18N_KEY.CUSTOMER + 'appendadd')">
              {{ record.contactType }}
            </div>
            <div v-else-if='record.contactType<=3'>

                               <span :value='text'>
                  {{ languageStorage == 'ti' ? $t(ContactPerson_FLAG_TI[text]) : languageStorage == 'zh-CN' ? $t(ContactPerson_FLAG[text]) : $t(ContactPerson_FLAG_EN[text])
                                 }}
                </span>
            </div>
            <div v-else>
              {{ $t(I18N_KEY.CUSTOMER + 'addbyhand') }}
            </div>
          </template>

          <template slot='relationType' slot-scope='text, record,index'>
            <Dict v-if="record.relationType!=''||index!= linkmanInfos.length-1"
                  :dict-code='DICT_CODE.REALTIONSHIP' :value='text'>
            </Dict>
            <dict-select
              v-else
              v-model='addcontactRealtion'
              :dict-code='DICT_CODE.ManualAddRelationship'
              :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
              :placeholder="$t('select')"
            />
          </template>

          <!--          <Dict slot='relationType' slot-scope='text' :dict-code='DICT_CODE.REALTIONSHIP' :value='text'>-->
          <!--          </Dict>-->
        </a-table>
      </a-card>
      <!--审批记录-->
      <a-card
        style='margin-top: 10px'
        type='inner'>
        <a-tabs v-model='currentTab'>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'approvalRecord')" key='1' forceRender>
            <a-table
              :columns='examineColumns'
              :dataSource='examineSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'>
              <Dict slot='approveTaskStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_TASK_STATUS'
                    :value='text' />
              <Dict slot='approveStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_STATUS' :value='text' />
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-card>


      <a-card
        style='margin-top: 10px'
        v-if='calllistDataScorce.length'
        type='inner'>
        <a-tabs v-model='currentTab'>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'calllist')" key='1' forceRender>
            <a-table
              :columns='calllistColumns'
              :dataSource='calllistDataScorce'
              :pagination='false'
              bordered
              ref='table'
              size='middle'>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-card>
      <!--移植过来的信息-->
      <a-card
        style='margin: 20px 0'
        type='inner'
      >
        <a-tabs v-model='currentTabTwo' @change='onTabChange'>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'repaymentPlan')" key='1'>
            <a-table
              :columns='repayPlanColumns'
              :dataSource='repayPlanSource()'
              :pagination='false'
              bordered
              ref='table'
              size='middle'
              :rowKey='(record) => record.index'>
              <Dict slot='status' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
              <template slot='totalAmt' slot-scope='text, record'>
                {{ record.totalAmt !== undefined ? record.totalAmt.toFixed(2) : '' }}
              </template>
              <template slot='lateFee' slot-scope='text, record'>
                {{ record.lateFee !== undefined ? record.lateFee.toFixed(2) : '' }}
              </template>
              <template slot='capital' slot-scope='text, record'>
                {{ record.capital !== undefined ? record.capital.toFixed(2) : '' }}
              </template>
            </a-table>
          </a-tab-pane>
<!--          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'approvalRecord')" key='2'>-->

<!--            <a-table-->
<!--              :columns='examineColumns'-->
<!--              :dataSource='examineSource'-->
<!--              :pagination='false'-->
<!--              bordered-->
<!--              ref='table'-->
<!--              size='middle'-->
<!--              :rowKey='(record) => record.index'>-->
<!--              <Dict slot='approveTaskStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_TASK_STATUS'-->
<!--                    :value='text' />-->
<!--              <Dict slot='approveStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_STATUS' :value='text' />-->
<!--            </a-table>-->
<!--          </a-tab-pane>-->
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'collectionRecord')" key='2'>
            <a-table
              :columns='collectionColumns'
              :dataSource='collectionSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'
              :rowKey='(record) => record.index'>
              <Dict slot='collectionTaskStatus' slot-scope='text' :dict-code='DICT_CODE.COLLECTION_TASK_STATUS'
                    :value='text' />
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'repaymentRecord')" key='3'>
            <a-table
              :columns='repayRecordColumns'
              :dataSource='repayRecordSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'
              :rowKey='(record) => record.index'>
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'flowRepayRecord')" key="4">
            <a-table
              :columns="flowRepayColumns"
              :dataSource="repayFlowSource"
              :pagination="false"
              bordered
              ref="table"
              size="middle"
              :rowKey="(record) => record.index">
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'historicalOrderRecords')" key="5">
            <a-table
              :columns="historicalOrdersColumns"
              :dataSource="historicalOrdersSource"
              :pagination="false"
              bordered
              ref="table"
              size="middle"
              :rowKey="(record) => record.index">
              <Dict slot='loanStatus' slot-scope='text' :dict-code='DICT_CODE.LOAN_STATUS' :value='text' />
              <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
              <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
              <Dict slot='overdueStatus' slot-scope='text' :dict-code='DICT_CODE.OVERDUE_STATUS' :value='text' />
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'jointBondOrderRecords')" key="6">
            <a-card :bordered="false" style="margin-bottom: 16px">
              <p>逾期订单:{{ orderSummary.overdueTotal }}</p>
              <p>逾期待还金额:{{ orderSummary.overdueMoneySum }}</p>
              <p>未到期订单:{{ orderSummary.notOverdueTotal }}</p>
              <p>未到期待还金额:{{ orderSummary.notOverdueMoneySum }}</p>
              <p>累计已还款金额:{{ orderSummary.amountTotalMoneySum }}</p>
            </a-card>
            <a-table
              :columns="historicalOrdersColumns"
              :dataSource="jointBondOrderSource"
              :pagination="false"
              bordered
              ref="table"
              size="middle"
              :rowKey="(record) => record.index">
              <Dict slot='loanStatus' slot-scope='text' :dict-code='DICT_CODE.LOAN_STATUS' :value='text' />
              <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS' :value='text' />
              <Dict slot='settleStatus' slot-scope='text' :dict-code='DICT_CODE.SETTLE_STATUS' :value='text' />
              <Dict slot='overdueStatus' slot-scope='text' :dict-code='DICT_CODE.OVERDUE_STATUS' :value='text' />
            </a-table>
          </a-tab-pane>
<!--          <a-tab-pane tab="同盾征信" key="7">-->
<!--            <a-card :bordered="false" style="margin-bottom: 16px">-->
<!--              <p>-->
<!--                <span style="font-weight: bold">是否是黑名单:</span>-->
<!--                <span v-if="detectVerifySource.IsBlack === 'hit'">命中</span>-->
<!--                <span v-if="detectVerifySource.IsBlack === 'no_record'">无记录</span>-->
<!--              </p>-->

<!--              <div style="display: flex; align-items: flex-start;">-->
<!--                &lt;!&ndash; 左表格 &ndash;&gt;-->
<!--                <div style="flex: 1;">-->
<!--                  <p style="font-weight: bold; margin-bottom: 10px;">-->
<!--                    CarpoIDCRP001 / CarpoMXCRP001 信用等级预测指标包-->
<!--                  </p>-->
<!--                  <table class="td-table">-->
<!--                    <colgroup>-->
<!--                      <col style="width: 65%;" />-->
<!--                      <col style="width: 35%;" />-->
<!--                    </colgroup>-->
<!--                    <tbody>-->
<!--                    <tr v-for="(item, index) in [-->
<!--              ['预测客户在365天内最近一次的信用等级', detectVerifySource.credit.m_last_level_credit_rating_365day],-->
<!--              ['预测客户在365天内连续为高风险信用等级的最大次数', detectVerifySource.credit.m_maxcontinue_highrisktimes_credit_rating_365day],-->
<!--              ['在365天内最近一次预测客户为高风险等级距今的天数', detectVerifySource.credit.m_length_highrisklast_credit_rating_365day],-->
<!--              ['预测客户在7天内最差的信用等级', detectVerifySource.credit.m_max_level_credit_rating_7day],-->
<!--              ['预测客户在30天内最差的信用等级', detectVerifySource.credit.m_max_level_credit_rating_30day],-->
<!--              ['预测客户在90天内最差的信用等级', detectVerifySource.credit.m_max_level_credit_rating_90day],-->
<!--              ['预测客户在180天内最差的信用等级', detectVerifySource.credit.m_max_level_credit_rating_180day],-->
<!--              ['预测客户在7天内最好的信用等级', detectVerifySource.credit.m_min_level_credit_rating_7day],-->
<!--              ['预测客户在30天内最好的信用等级', detectVerifySource.credit.m_min_level_credit_rating_30day],-->
<!--              ['预测客户在90天内最好的信用等级', detectVerifySource.credit.m_min_level_credit_rating_90day],-->
<!--              ['预测客户在180天内最好的信用等级', detectVerifySource.credit.m_min_level_credit_rating_180day],-->
<!--              ['预测客户在7天内平均的信用等级', detectVerifySource.credit.m_avg_level_credit_rating_7day],-->
<!--              ['预测客户在30天内平均的信用等级', detectVerifySource.credit.m_avg_level_credit_rating_30day],-->
<!--              ['预测客户在90天内平均的信用等级', detectVerifySource.credit.m_avg_level_credit_rating_90day],-->
<!--              ['预测客户在180天内平均的信用等级', detectVerifySource.credit.m_avg_level_credit_rating_180day],-->
<!--              ['预测客户在30天内为低风险信用等级的次数', detectVerifySource.credit.m_cnt_lowrisk_credit_rating_30day],-->
<!--              ['预测客户在180天内为低风险信用等级的次数', detectVerifySource.credit.m_cnt_lowrisk_credit_rating_180day],-->
<!--              ['预测客户在30天内为高风险信用等级的次数', detectVerifySource.credit.m_cnt_highrisk_credit_rating_30day],-->
<!--              ['预测客户在180天内为高风险信用等级的次数', detectVerifySource.credit.m_cnt_highrisk_credit_rating_180day]-->
<!--            ]" :key="index">-->
<!--                      <td>{{ item[0] }}</td>-->
<!--                      <td>{{ item[1] }}</td>-->
<!--                    </tr>-->
<!--                    </tbody>-->
<!--                  </table>-->
<!--                </div>-->

<!--                &lt;!&ndash; 右表格 &ndash;&gt;-->
<!--                <div style="flex: 1; padding-left: 50px;">-->
<!--                  <p style="font-weight: bold; margin-bottom: 10px;">-->
<!--                    CarpoMXMPSP001 多国多头V1.0指标包-->
<!--                  </p>-->
<!--                  <table class="td-table">-->
<!--                    <colgroup>-->
<!--                      <col style="width: 65%;" />-->
<!--                      <col style="width: 35%;" />-->
<!--                    </colgroup>-->
<!--                    <tbody>-->
<!--                    <tr>-->
<!--                      <td>过去7天发生信贷事件的机构数</td>-->
<!--                      <td>{{ detectVerifySource.multi.m_cnt_loan_credit_institution_7day }}</td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td>过去30天发生信贷事件的机构数</td>-->
<!--                      <td>{{ detectVerifySource.multi.m_cnt_loan_credit_institution_30day }}</td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td>过去90天发生信贷事件的机构数</td>-->
<!--                      <td>{{ detectVerifySource.multi.m_cnt_loan_credit_institution_90day }}</td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <td>过去180天发生信贷事件的机构数</td>-->
<!--                      <td>{{ detectVerifySource.multi.m_cnt_loan_credit_institution_180day }}</td>-->
<!--                    </tr>-->
<!--                    </tbody>-->
<!--                  </table>-->
<!--                </div>-->
<!--              </div>-->
<!--            </a-card>-->
<!--          </a-tab-pane>-->
<!--          <a-tab-pane tab="btc征信" key="8">-->
<!--            <a-card :bordered="false" style="margin-bottom: 16px">-->
<!--              <div style="display: flex; justify-content: flex-start; align-items: flex-start;">-->
<!--                &lt;!&ndash; 第一列：多头查询次数 &ndash;&gt;-->
<!--                <div style="flex: 1;">-->
<!--                  <p style="font-weight: bold; margin-bottom: 10px;">多头查询次数</p>-->
<!--                  <table class="btc-table">-->
<!--                    <colgroup>-->
<!--                      <col style="width: 65%;" />-->
<!--                      <col style="width: 35%;" />-->
<!--                    </colgroup>-->
<!--                    <tbody>-->
<!--                    <tr><td>近1周多头查询次数</td><td>{{ BtcVerifySource.btc_dt_cnt_1w }}</td></tr>-->
<!--                    <tr><td>近2周多头查询次数</td><td>{{ BtcVerifySource.btc_dt_cnt_2w }}</td></tr>-->
<!--                    <tr><td>近1月多头查询次数</td><td>{{ BtcVerifySource.btc_dt_cnt_1m }}</td></tr>-->
<!--                    <tr><td>近2月多头查询次数</td><td>{{ BtcVerifySource.btc_dt_cnt_2m }}</td></tr>-->
<!--                    <tr><td>近3月多头查询次数</td><td>{{ BtcVerifySource.btc_dt_cnt_3m }}</td></tr>-->
<!--                    <tr><td>近6月多头查询次数</td><td>{{ BtcVerifySource.btc_dt_cnt_6m }}</td></tr>-->
<!--                    </tbody>-->
<!--                  </table>-->
<!--                </div>-->

<!--                &lt;!&ndash; 第二列：多头查询平台数 &ndash;&gt;-->
<!--                <div style="flex: 1; padding-left: 50px;">-->
<!--                  <p style="font-weight: bold; margin-bottom: 10px;">多头查询平台数</p>-->
<!--                  <table class="btc-table">-->
<!--                    <colgroup>-->
<!--                      <col style="width: 65%;" />-->
<!--                      <col style="width: 35%;" />-->
<!--                    </colgroup>-->
<!--                    <tbody>-->
<!--                    <tr><td>近1周多头查询平台数</td><td>{{ BtcVerifySource.btc_dta_cnt_1w }}</td></tr>-->
<!--                    <tr><td>近2周多头查询平台数</td><td>{{ BtcVerifySource.btc_dta_cnt_2w }}</td></tr>-->
<!--                    <tr><td>近1月多头查询平台数</td><td>{{ BtcVerifySource.btc_dta_cnt_1m }}</td></tr>-->
<!--                    <tr><td>近2月多头查询平台数</td><td>{{ BtcVerifySource.btc_dta_cnt_2m }}</td></tr>-->
<!--                    <tr><td>近3月多头查询平台数</td><td>{{ BtcVerifySource.btc_dta_cnt_3m }}</td></tr>-->
<!--                    <tr><td>近6月多头查询平台数</td><td>{{ BtcVerifySource.btc_dta_cnt_6m }}</td></tr>-->
<!--                    </tbody>-->
<!--                  </table>-->
<!--                </div>-->

<!--                &lt;!&ndash; 第三列：BTC信用分 &ndash;&gt;-->
<!--                <div style="flex: 1; padding-left: 50px;">-->
<!--                  <p style="font-weight: bold; margin-bottom: 10px;">BTC信用分</p>-->
<!--                  <table class="btc-table">-->
<!--                    <colgroup>-->
<!--                      <col style="width: 65%;" />-->
<!--                      <col style="width: 35%;" />-->
<!--                    </colgroup>-->
<!--                    <tbody>-->
<!--                    <tr><td>BTC信用分v1</td><td>{{ BtcVerifySource.btc_score_v1 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v2</td><td>{{ BtcVerifySource.btc_score_v2 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v3</td><td>{{ BtcVerifySource.btc_score_v3 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v4</td><td>{{ BtcVerifySource.btc_score_v4 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v5</td><td>{{ BtcVerifySource.btc_score_v5 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v6</td><td>{{ BtcVerifySource.btc_score_v6 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v7</td><td>{{ BtcVerifySource.btc_score_v7 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v8</td><td>{{ BtcVerifySource.btc_score_v8 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v9</td><td>{{ BtcVerifySource.btc_score_v9 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v10</td><td>{{ BtcVerifySource.btc_score_v10 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v11</td><td>{{ BtcVerifySource.btc_score_v11 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v12</td><td>{{ BtcVerifySource.btc_score_v12 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v13</td><td>{{ BtcVerifySource.btc_score_v13 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v14</td><td>{{ BtcVerifySource.btc_score_v14 }}</td></tr>-->
<!--                    <tr><td>BTC信用分v15</td><td>{{ BtcVerifySource.btc_score_v15 }}</td></tr>-->
<!--                    </tbody>-->
<!--                  </table>-->
<!--                </div>-->

<!--              </div>-->
<!--            </a-card>-->
<!--          </a-tab-pane>-->

        </a-tabs>
      </a-card>
      <!--  审批项信息  -->
      <a-card
        :title="$t(I18N_KEY.HumanReviewDataSet + 'ApprovalIteminfo')"
        type='inner' v-if='showForm'>
        <div class='chose-one'>
          <div class='chose-one-item'>1. {{ $t(I18N_KEY.HumanReviewDataSet + 'IDPhotonormal') }}</div>
          <!--  选项信息   -->
          <div>
            <a-checkbox :value='0' :checked='Q_cust_image_normal' @change='radioOneChange($event)' v-model='normOne'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'Normalstatus')
              }}
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeOne' :disabled='disable0ne' v-model='selectedOptionsOne'>
            <a-row style='width: 100%'>
              <a-col style='width: 25%'>
                <a-checkbox value='1'>{{ $t(I18N_KEY.HumanReviewDataSet + 'LackIDCardOrNoPhoto') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='2'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardNearExpiration') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='3'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardExpired') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='4'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardphotoForgery') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='5'>{{ $t(I18N_KEY.HumanReviewDataSet + 'PhotocopyIDCard') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='6'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardForgery') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='7'>{{ $t(I18N_KEY.HumanReviewDataSet + 'DamagedIDCard') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='8'>{{ $t(I18N_KEY.HumanReviewDataSet + 'MyIDCardDoesntMatchMe') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='9'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardPhotoIsPasted') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='10'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardPhotoIsNotClear') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='11'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardIsNotClear') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='12'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardPhotoIsTooDark') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='13'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDCardPhotoIsIncomplete') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='14'>{{ $t(I18N_KEY.HumanReviewDataSet + 'fontOfIDCardIsDifferentFromNormal') }}
                </a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='15'>{{ $t(I18N_KEY.HumanReviewDataSet + 'typesettingOfIDCardIsInclined') }}
                </a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='16'>{{ $t(I18N_KEY.HumanReviewDataSet + 'NoSignatureOnTheIDCard') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='17'>{{ $t(I18N_KEY.HumanReviewDataSet + 'OthersValue') }}</a-checkbox>
              </a-col>

            </a-row>
          </a-checkbox-group>
          <div class='chose-one-item'>2. {{ $t(I18N_KEY.HumanReviewDataSet + 'livingBodyNormal') }}</div>
          <div>
            <a-checkbox :value='0' :checked='Q_cust_living_body_normal' @change='radioTwoChange($event)'
                        v-model='normTwo'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'Normalstatus') }}
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeTwo' :disabled='disableTwo' style='width: 100%'
                            v-model='selectedOptionsTwo'>
            <a-row style='width: 100%'>
              <a-col style='width: 25%'>
                <a-checkbox value='1'>{{ $t(I18N_KEY.HumanReviewDataSet + 'livingphotoDoesntMatchIDCard') }}
                </a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='2'>{{ $t(I18N_KEY.HumanReviewDataSet + 'OthersValue') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
              </a-col>
              <a-col style='width: 25%'>
              </a-col>
            </a-row>
          </a-checkbox-group>

          <div class='chose-one-item'>3. {{ $t(I18N_KEY.HumanReviewDataSet + 'phoneAnsweredProperly') }}</div>
          <div>
            <a-checkbox :value='0' :checked='Q_contact_phone_normal' @change='radioFourChange($event)'
                        v-model='normFour'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'Normalstatus') }}
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeFour' :disabled='disableFour' v-model='selectedOptionsFour'>
            <a-row style='width: 100%'>
              <a-col style='width: 25%'>
                <a-checkbox value='1'>{{ $t(I18N_KEY.HumanReviewDataSet + 'PhoneNumError') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='2'>{{ $t(I18N_KEY.HumanReviewDataSet + 'cantAnswerPhone') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='3'>{{ $t(I18N_KEY.HumanReviewDataSet + 'PhoneEmpty') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='4'>{{ $t(I18N_KEY.HumanReviewDataSet + 'phoneNumIsntMyOwn') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='5'>{{ $t(I18N_KEY.HumanReviewDataSet + 'IDidntAnswerThePhone') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='6'>{{ $t(I18N_KEY.HumanReviewDataSet + 'NonpersonalVerificationInfo') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='7'>{{ $t(I18N_KEY.HumanReviewDataSet + 'CustomerRequestsCloseOrder') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='8'>{{ $t(I18N_KEY.HumanReviewDataSet + 'CustomerDoesntAcknowledgeOrder') }}
                </a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='9'>{{ $t(I18N_KEY.HumanReviewDataSet + 'OthersValue') }}</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>

          <div class='chose-one-item'>4. {{ $t(I18N_KEY.HumanReviewDataSet + 'ContactInformationNormal') }}</div>
          <div>
            <a-checkbox :value='0' :checked='Q_cust_contactperson_normal' @change='radioThreeChange($event)'
                        v-model='normThree'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'Normalstatus') }}
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeThree' :disabled='disableThree' style='width: 100% '
                            v-model='selectedOptionsThree'>
            <a-row style='width: 100%'>
              <a-col style='width: 25%'>
                <a-checkbox value='1'>{{ $t(I18N_KEY.HumanReviewDataSet + 'ContactNameException') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='2'>{{ $t(I18N_KEY.HumanReviewDataSet + 'ContactPhoneException') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='3'>{{ $t(I18N_KEY.HumanReviewDataSet + 'LackConnections') }}</a-checkbox>
              </a-col>
              <a-col style='width: 25%'>
                <a-checkbox value='4'>{{ $t(I18N_KEY.HumanReviewDataSet + 'OthersValue') }}</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>


          <div class='chose-one-item'>5. {{ $t(I18N_KEY.HumanReviewDataSet + 'linenormal') }}</div>
          <div>
            <a-checkbox :value='0' :checked='Q_line_normal' @change='radiFiveChange($event)'
                        v-model='normFive'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'linenormals') }}
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeFive' :disabled='disableFive' v-model='selectedOptionsFive'>
            <a-row style='width: 100%'>
              <a-col style='width: 100%'>
                <a-checkbox value='1'>{{ $t(I18N_KEY.HumanReviewDataSet + 'Unabletoadd') }}</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>

<!--          facebook是否正常-->
          <div class='chose-one-item'>6. {{ $t(I18N_KEY.HumanReviewDataSet + 'fbtitle') }}</div>
          <div>
            <a-checkbox :value='0' :checked='Q_Facebook_normal' @change='radiSevenChange($event)'
                        v-model='normSeven'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'fbnormals') }}
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeSeven' :disabled='disableSeven' v-model='selectedOptionsSeven'>
            <a-row style='width: 100%'>
              <a-col style='width: 100%'>
                <a-checkbox value='1'>
                  {{ $t(I18N_KEY.HumanReviewDataSet + 'fbnopage') }}
                </a-checkbox>
                <a-checkbox value='2'>
                  {{ $t(I18N_KEY.HumanReviewDataSet + 'fbhavepagenofans') }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
           <!--敏感职业-->
          <div class='chose-one-item'>7.{{ $t(I18N_KEY.HumanReviewDataSet + 'Sensitiveoccupation') }}</div>
          <div>
            <a-checkbox :value='0' :checked='Q_Sensitiveoccupation_normal' @change='radiSixChange($event)'
                        v-model='normSix'>
               {{ $t(I18N_KEY.HumanReviewDataSet + 'noSensitiveoccupation') }}
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeSix' :disabled='disableSix' v-model='selectedOptionsSix'>
            <a-row style='width: 100%'>
              <a-col style='width: 100%'>
                <a-checkbox value='1'>
                  {{ $t(I18N_KEY.HumanReviewDataSet + 'yesSensitiveoccupation') }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <div style='height: fit-content !important;display: flex;
          justify-content: flex-start;align-items: center; margin-bottom: 20px'>
          <p style='font-weight: bold;margin: 0 !important;'>{{ $t(I18N_KEY.HumanReviewDataSet + 'isinsatll') }}</p>
            <p style='margin: 0 20px !important;color: #1890FF;' v-if='creditappsNum>0'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'isinsatllyes') }}
              {{ $t(I18N_KEY.HumanReviewDataSet + 'insatllpartone') }} {{creditappsNum}}
              {{ $t(I18N_KEY.HumanReviewDataSet + 'insatllparttwo') }}
            </p>
            <p style='margin: 0 20px !important;color: #1890FF;' v-else>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'isinsatllno') }}
            </p>
            <a-button type='primary' @click='getCreditAppData(basicInfo.mobileNo)' style='height: 40px; width: 100px;'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'refresh') }}
            </a-button>
          </div>
          <div class='chose-one-item'>{{ $t(I18N_KEY.HumanReviewDataSet + 'RemarkValue') }}</div>
          <div>
            <a-textarea :placeholder="$t(I18N_KEY.HumanReviewDataSet + 'inputRemark')"
                        @change='TextareaonChange($event)' v-model='remarkValue'>

            </a-textarea>
          </div>
        </div>
        <div style='display: flex;flex-direction: row'>
          <div style='height: 40px;width: 200px; margin-top: 30px'>
            <a-button type='primary' @click='submitInfo' style='height: 40px; width: 200px;'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'submitValue') }}
            </a-button>
          </div>
          <div style='height: 40px;width: 200px; margin-top: 30px'>
            <a-button type='primary' @click='pendingReviewFn' style='height: 40px; width: 200px;margin-left: 30px'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'pendingReview') }}
            </a-button>
          </div>
        </div>
      </a-card>
    </a-spin>
    <div
      v-if='auditDrawer && !loading'
      :class="{ 'setting-drawer-handle': true, active: visible }" @click='handelDrawer(!visible)'>
      <a-icon type='double-left' v-if='!visible' />
      <a-icon type='double-right' v-if='visible' />
    </div>
    <!--    非空校验弹框-->
    <a-modal v-model='ModalVisible' title='操作提醒' @ok='handleOk'>
      <p>有必填未填写！！</p>
    </a-modal>
    <a-drawer
      v-if='auditDrawer'
      width='600'
      placement='right'
      title='审批'
      :visible='visible'
      :maskClosable='false'
      :getContainer='drawContainer'
      :wrapStyle="{height: 'calc(100% - 20px)',overflow: 'auto',paddingBottom: '20px'}"
      @close='closeDrawer'
    >
      <div class='audit-form'>
        <a-form :form='basicForm' layout='vertical'>

          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q1')">
            <a-radio-group
              v-decorator="['Q_cust_phone_get', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='2'>{{ $t(I18N_KEY.APPROVAL + 'noresponse') }}</a-radio>
              <a-radio value='3'>{{ $t(I18N_KEY.APPROVAL + 'invalidnumber') }}</a-radio>
              <a-radio value='4'>{{ $t(I18N_KEY.APPROVAL + 'switchoff') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'reject') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q2')">
            <a-radio-group
              v-decorator="['Q_cust_info_confirm', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q3')">
            <a-radio-group
              v-decorator="['Q_cust_phone_read', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q4')">
            <a-radio-group
              v-decorator="['Q_cust_Birth_read', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q5')">
            <a-radio-group
              v-decorator="['Q_cust_duration_amt_question', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q6')">
            <a-radio-group
              v-decorator="['Q_contact_phone_read', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='2'>{{ $t(I18N_KEY.APPROVAL + 'noresponse') }}</a-radio>
              <a-radio value='3'>{{ $t(I18N_KEY.APPROVAL + 'invalidnumber') }}</a-radio>
              <a-radio value='4'>{{ $t(I18N_KEY.APPROVAL + 'switchoff') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'reject') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q7')">
            <a-radio-group
              v-decorator="['Q_cust_contact_know', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.ORDER + 'approvalRemark')">
            <a-textarea
              v-decorator="['remark']"
              :rows='4' />
          </a-form-item>
        </a-form>
      </div>
      <div class='footer'>
        <a-button style='marginRight: 8px' @click='closeDrawer'>
          {{ $t('cancel') }}
        </a-button>
        <a-button :loading='confirmLoading' @click='submitAuditForm' type='primary'>
          {{ $t('confirm') }}
        </a-button>
      </div>
    </a-drawer>
    <!-- 点击本人电话的弹窗 -->
    <a-modal
      width='1300px'
      :title="$t(I18N_KEY.ORDER + 'approvalRemark')"
      :visible='ContactVisible'
      :confirm-loading='ContactconfirmLoading'
      @ok='ContacthandleOk'
      @cancel='ContacthandleCancel'
    >
      <div>
        <a-checkbox-group v-if='showFormContant' @change='rmarkboxChange' :disabled='disableRemark'
                          v-model='remarkOptions' style='width: 100%'>
          <a-row style='width: 100%'>
            <div style='display:flex;justify-content: flex-start;width: 100%;margin-bottom: 20px;font-weight: bold'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'NotAnsweringCall') }}
            </div>
          </a-row>
          <a-row style='width: 100%'>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'turnOfftwo')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'turnOfftwo') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'leaveSmstwo')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'leaveSmstwo') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'invalidNumber')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'invalidNumber') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'notAnswering')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'notAnswering') }}
              </a-checkbox>
            </a-col>
          </a-row>
          <a-row style='width: 100%'>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'doNotContacted')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'doNotContacted') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'doNotKnowBorrower')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'doNotKnowBorrower') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
            </a-col>
            <a-col style='width: 25%'>
            </a-col>
          </a-row>
          <a-row style='width: 100%'>
            <div style='display:flex;justify-content: flex-start;width: 100%;margin-bottom: 20px;font-weight: bold'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'ReceivingCall') }}
            </div>
          </a-row>
          <a-row style='width: 100%'>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'HeIsAFatherl')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'HeIsAFatherl') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'SheIsAMother')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'SheIsAMother') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'SheIsAWife')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'SheIsAWife') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'HeIsAHusband')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'HeIsAHusband') }}
              </a-checkbox>
            </a-col>
          </a-row>
          <a-row style='width: 100%'>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'olderBrotherYoungerBrother')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'olderBrotherYoungerBrother') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'olderSisterYoungerSisterAunt')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'olderSisterYoungerSisterAunt') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'heWorkmate')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'heWorkmate') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'SheWorkmate')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'SheWorkmate') }}
              </a-checkbox>
            </a-col>
          </a-row>
          <a-row style='width: 100%'>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'NotConfirmRlationship')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'NotConfirmRlationship') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'ReceiveDisconnect')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'ReceiveDisconnect') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'Askdone')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'Askdone') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'ThoughtScammer')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'ThoughtScammer') }}
              </a-checkbox>
            </a-col>
          </a-row>
          <a-row style='width: 100%'>
            <div style='display:flex;justify-content: flex-start;width: 100%;margin-bottom: 20px;font-weight: bold'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'Notification') }}
            </div>
          </a-row>
          <a-row style='width: 100%'>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'HeDoesntKnowBorrower')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'HeDoesntKnowBorrower') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'SheDoesntKnowBorrower')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'SheDoesntKnowBorrower') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'NotBeenInTouchWithBorrower')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'NotBeenInTouchWithBorrower') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
            </a-col>
          </a-row>
        </a-checkbox-group>

        <a-checkbox-group v-else @change='rmarkboxChange' :disabled='disableRemark' v-model='remarkOptions'
                          style='width: 100%'>
          <a-row style='width: 100%'>
            <div style='display:flex;justify-content: flex-start;width: 100%;margin-bottom: 20px;font-weight: bold'>
              {{ $t(I18N_KEY.HumanReviewDataSet + 'Borrower') }}
            </div>
          </a-row>
          <a-row style='width: 100%'>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'ConfirmIdentityIsCorrect')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'ConfirmIdentityIsCorrect') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'NotAnsweringTheCall')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'NotAnsweringTheCall') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'turnOff')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'turnOff') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'InvalidNumberCloseService')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'InvalidNumberCloseService') }}
              </a-checkbox>
            </a-col>
          </a-row>
          <a-row style='width: 100%'>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'NotBorrower')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'NotBorrower') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
              <a-checkbox :value="$t(I18N_KEY.HumanReviewDataSet + 'leaveSms')">
                {{ $t(I18N_KEY.HumanReviewDataSet + 'leaveSms') }}
              </a-checkbox>
            </a-col>
            <a-col style='width: 25%'>
            </a-col>
            <a-col style='width: 25%'>
            </a-col>
          </a-row>
        </a-checkbox-group>
        <a-textarea :placeholder="$t(I18N_KEY.HumanReviewDataSet + 'inputRemark')"
                    @change='TextareaonRemarkChange($event)' v-model='phoneRemarkValue'>

        </a-textarea>
      </div>
    </a-modal>

  </div>

</template>
<script>
import { DetailList } from '@/components'
import { mapActions, mapGetters } from 'vuex'
import CryptoJS from 'crypto-js'

import {
  REBORROW_FLAG,
  REBORROW_FLAG_EN,
  REBORROW_FLAG_TI,
  SEX,
  CONTACT_TYPE,
  ORDER_TYPE_CN,
  CURP_TYPE,
  COLLECT_TYPE,
  ORDER_TYPE_EN, ORDER_TYPE_TI, ContactPerson_FLAG_TI, ContactPerson_FLAG_EN, ContactPerson_FLAG
} from '@/constants/status'
import Dict from '../modules/Dict'
import imageMixin from '@/mixins/image-mixin'
import { modExamineTaskUser, peopleExamine, sendEmailfn, sendsmsTips } from '@/webpublicapi/approval'
import { editCustomer, editFacebook, addAlternateContact , getCreditApp} from '@/webpublicapi/customer'
import lang from '@/i18n/lang'
import i18n from '@/i18n'
import sendGroupList from '@/views/webpublic/operation/SendGroupList.vue'
import DictSelect from '@/views/webpublic/modules/DictSelect.vue'
import { getAllOrderListSummary, getPlatformAllOrderList ,getBtcVerify,getDetectVerify} from '@/webpublicapi/order'
// import HumanReviewDataSet from '../src/i18n/lang/modules/HumanReviewDataSet'


const DetailListItem = DetailList.Item

const I18N_KEY = {
  CUSTOMER: 'customer.',
  ORDER: 'order.',
  APPROVAL: 'approval.',
  HumanReviewDataSet: 'HumanReviewDataSet.'
}

export default {
  props: {
    orderId: {
      type: [String, Number],
      default: undefined
    },
    custInfoId: {
      type: [String, Number],
      default: undefined
    },
    taskId: {
      type: [String, Number],
      default: undefined
    },
    auditDrawer: {
      type: Boolean,
      default: false
    },
    approvalStatus: {
      type: [String, Number],
      default: undefined
    },
    phoneprops: {
      type: [String, Number],
      default: null
    }

  },
  components: {
    DictSelect,
    DetailList,
    DetailListItem,
    Dict
  },
  mixins: [imageMixin],
  data() {
    return {
        orderSummary: {},
      addressBookSize: 0,
      jointBondOrderSource: [],
      historicalOrdersSource: [],
      detectVerifySource:{
        credit: {},
        multi: {}
      },
      BtcVerifySource:{},
      creditappsNum:0,
      calllistDataScorce: [],
      checkedpass: false,
      showhadleContact: true,
      //手动添加联系人的时候有一个标志 ，显示电话号码
      recentcontactNum: '', //记录当前有几个联系人，
      addcontactRealtion: '',//添加联系人 --关系
      addcontactName: '',//添加联系人 ---名称
      addcontactPhoneNum: '',//添加联系人 ---电话号码
      //存储下一个联系人是第几个
      nestlineknum: '',
      isShowContacts: true,//控制四个联系人后面的备注显示与隐藏
      showmyself: true, //打本人
      showFormContant: false,//控制点击本人备注还是联系备注 true显示联系人的，false显示本人的
      normremarkChecked: false,
      normRemark: true,
      remarkOptions: [],
      disableRemark: false,
      btndisableFBValue: true,//编辑fb
      btndisableEmailValue: true,//编辑email
      btndisablelineValue:true,//编辑line
      btndisabletiktokValue:true,//编辑line
      btndisableValue: false,
      showzhudedianhua: false,
      showFinishImg: 0,
      //选项数据回显
      selectedOptionsOne: [],
      selectedOptionsTwo: [],
      selectedOptionsThree: [],
      selectedOptionsFour: [],
      selectedOptionsFive: [],
      selectedOptionsSix: [],
      selectedOptionsSeven: [],
      normOne: false,
      normTwo: false,
      normThree: false,
      normFour: false,
      normFive: false,
      normSix: false,
      normSeven: false,
      ContactVisible: false,
      ContactconfirmLoading: false,
      showEmialInput: false,
      emailvalue: '.com',
      emailEditID: '',
      showFBInput: false,
      FBvalue: '.com',
      FBEditID: '',
      TikTokvalue: '',
      TikTokEditID: '',
      linevalue: '',
      lineEditID: '',
      showLineInput: false,
      tiktokvalue: '',
      tiktokEditID: '',
      showtiktokInput: false,
      lang,
      i18n,
      remarkValue: '',//备注栏的默认内容
      bigRemarkValue: '',
      phoneRemarkValue: '',//电话备注栏的默认内容
      ModalVisible: false,//校验提示弹框
      showForm: false,//是否展示审批项信息 默认不显示 【approvalStatus】为2的时候
      //存储四个正常按钮的变量
      Q_cust_image_normal: false,
      Q_cust_living_body_normal: false,
      Q_cust_contactperson_normal: false,
      Q_contact_phone_normal: false,
      Q_line_normal: false,
      Q_Sensitiveoccupation_normal: false,
      Q_Facebook_normal: false,
      //非正常情况下多选的选项的数组
      image_normal_array: [],
      living_body_normal_array: [],
      contactperson_normal_array: [],
      ontact_phone_array: [],
      line_normal_array: [],
      Sensitive_occupation_array: [],
      Facebook_normal_array:[],

      //是否禁用
      disable0ne: false,
      disableTwo: false,
      disableThree: false,
      disableFour: false,
      disableFive: false,
      disableSix: false,
      disableSeven: false,
      //子选项禁用时候的保留值
      childValueOne: [],
      childValueTwo: [],
      childValueThree: [],
      childValueFour: [],
      childValueFive: [],
      childValueSix: [],
      childValueSeven: [],
      //存储刚才打开的联系人是谁
      contactWhoName: '',
      contactWhoPhone: '',
      contactWhoType: '',
      //传给后端的item
      chooseItems: [
        {
          'itemCode': 'Q_cust_image_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_cust_living_body_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_cust_contactperson_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_contact_phone_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_line_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_Sensitiveoccupation_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_Facebook_normal',
          'itemResult': []
        }
      ],
      I18N_KEY,
      REBORROW_FLAG,
      REBORROW_FLAG_EN,
      REBORROW_FLAG_TI,
      ORDER_TYPE_CN,
      ORDER_TYPE_EN,
      ORDER_TYPE_TI,
      SEX,
      CONTACT_TYPE,
      ContactPerson_FLAG_TI,
      ContactPerson_FLAG_EN,
      ContactPerson_FLAG,
      COLLECT_TYPE,
      visible: false,
      loading: true,
      confirmLoading: false,
      basicForm: this.$form.createForm(this),
      listItem: {},
      openDrawerCount: 0,
      currentTab: '1',
      currentTabTwo: '1',
      linkColumns: [
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactType'),
          dataIndex: 'contactType',
          key: 'contactType',
          align: 'center',
          scopedSlots: { customRender: 'contactType' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactRelationship'),
          dataIndex: 'relationType',
          key: 'relationType',
          align: 'center',
          scopedSlots: { customRender: 'relationType' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactName'),
          dataIndex: 'contactName',
          key: 'contactName',
          align: 'center',
          scopedSlots: { customRender: 'contactName' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactPhone'),
          dataIndex: 'contactPhone',
          key: 'contactPhone',
          align: 'center',
          width: '800px',
          scopedSlots: { customRender: 'contactPhonteValue' }
        }
      ],
      repayPlanColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'totalPeriod'),
          dataIndex: 'totalPeriod',
          align: 'center',
          customRender: (text, record, index) => {
            record.index = index
            return text
          }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'currentPeriod'),
          dataIndex: 'period',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'startingTime'),
          dataIndex: 'beginDate',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'expireTime'),
          dataIndex: 'endDate',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'totalRepayableAmount'),
          dataIndex: 'totalAmt',
          align: 'center',
          scopedSlots: { customRender: 'totalAmt' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'principalPayable'),
          dataIndex: 'capital',
          align: 'center',
          scopedSlots: { customRender: 'capital' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'overdueDays'),
          dataIndex: 'overdueDays',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'forfeitPenalty'),
          dataIndex: 'lateFee',
          align: 'center',
          scopedSlots: { customRender: 'lateFee' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'status'),
          dataIndex: 'status',
          align: 'center'
        }
      ],
      collectionColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'collectionStaff'),
          dataIndex: 'followUserName',
          align: 'center',
          customRender: (text, record, index) => {
            record.index = index
            return text
          }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'collectionTime'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'collectionTaskStatus'),
          dataIndex: 'collectionTaskStatus',
          align: 'center',
          scopedSlots: { customRender: 'collectionTaskStatus' }
        }
      ],
      repayRecordColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'payOrderNo'),
          dataIndex: 'payOrderNo',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payType'),
          dataIndex: 'payType',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payAmount'),
          dataIndex: 'payAmount',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payRecipt'),
          dataIndex: 'payRecipt',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'description'),
          dataIndex: 'description',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'errorDescription'),
          dataIndex: 'errorDescription',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'recordTime'),
          dataIndex: 'recordTime',
          align: 'center'
        }
      ],
      flowRepayColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'flowId'),
          dataIndex: 'id',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'channel'),
          dataIndex: 'channel',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payType'),
          dataIndex: 'payType',
          align:"center",
          customRender: (text) => {
            return  text === "00" ?  '正常还款' : '展期还款'
          }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payLink'),
          dataIndex: 'payLink',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'repayAmount'),
          dataIndex: 'amount',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payinId'),
          dataIndex: 'payinId',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payoutId'),
          dataIndex: 'payoutId',
          align:"center",
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'repayStatus'),
          dataIndex: 'status',
          align:"center",
          customRender: (text) => {
            return  text === "03"
              ?  '未还款'
              : text === "02"
                ?  '还款失败'
                : text === "01" ? '还款成功':'未知'
          }
        }
      ],
      historicalOrdersColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'custType'),
          align: 'left',
          dataIndex: 'loanCount',
          customRender: (text, row) => {
            if (text > 1) {
              return '老户'
            } else {
              return '新户'
            }
          }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('phoneNo'),
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: this.$t('customer.names'),
          align: 'left',
          dataIndex: 'names'
        },
        {
          title: this.$t('customer.surnames'),
          align: 'left',
          dataIndex: 'surnames'
        },
        {
          title: this.$t('customer.curp'),
          align: 'left',
          dataIndex: 'curp'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'loanAmount'),
          align: 'left',
          dataIndex: 'paymentAmt'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'productName'),
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'loanStatus'),
          align: 'left',
          dataIndex: 'loanStatus',
          scopedSlots: { customRender: 'loanStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStatus'),
          align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'settlementStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'overdueStatus'),
          align: 'left',
          dataIndex: 'overdueStatus',
          scopedSlots: { customRender: 'overdueStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'applicationTime'),
          align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'expireTime'),
          align: 'left',
          dataIndex: 'endDate'
        }
      ],
      examineColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStaff'),
          dataIndex: 'examineUserName',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalTime'),
          dataIndex: 'examineTime',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalTaskStatus'),
          dataIndex: 'approveTaskStatus',
          align: 'center',
          scopedSlots: { customRender: 'approveTaskStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStatus'),
          dataIndex: 'approveStatus',
          align: 'center',
          scopedSlots: { customRender: 'approveStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalRemark'),
          dataIndex: 'comment',
          align: 'center'
        }
      ],
      calllistColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'callusername'),
          dataIndex: 'username',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'calltimevalue'),
          dataIndex: 'duration',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'RecordingAccessAddress'),
          dataIndex: 'recordUrl',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'connectionTime'),
          dataIndex: 'answerTime',
          align: 'center'
        }, {
          title: this.$t(I18N_KEY.ORDER + 'hangingUpReason'),
          dataIndex: 'hangupCause',
          align: 'center'
        }
      ],
      FILE_TYPE: {
        'aadhaar_front': this.$t(I18N_KEY.CUSTOMER + 'aadhaarFront'),
        'aadhaar_back': this.$t(I18N_KEY.CUSTOMER + 'aadhaarBack'),
        'pan_front': this.$t(I18N_KEY.CUSTOMER + 'panFront'),
        // 'face_photo_list': this.$t(I18N_KEY.CUSTOMER + 'facePhotoList'),
        'face_photo_list': this.$t(I18N_KEY.CUSTOMER + 'hanldeidcard'),
        'card_front': this.$t(I18N_KEY.CUSTOMER + 'idcardFront'),
        'card_back': this.$t(I18N_KEY.CUSTOMER + 'idcardNegative'),
        'line_code_image':this.$t(I18N_KEY.CUSTOMER + 'lineqrcode'),
        'card_voter':this.$t(I18N_KEY.CUSTOMER + 'hanldeidcard'),
        'hydropower_image':this.$t(I18N_KEY.CUSTOMER + 'Utilitybill'),
        'payroll_image':this.$t(I18N_KEY.CUSTOMER + 'Payslip'),
        'work_prove_image':this.$t(I18N_KEY.CUSTOMER + 'workpermit')
      },
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 20
      }
    }
  },
  computed: {
    sendGroupList() {
      return sendGroupList
    },
    ...mapGetters('language', ['languageStorage']),
    ...mapGetters('language', ['languageStorage']),
    ...mapGetters('order', [
      'orderDetail',
      'examineLogList',
      'repayPlanList',
      'repayRecordList',
      'repayFlowList'
    ]),
    ...mapGetters('platformCollection', [
        'allCollectionTaskList'
    ]),
    ...mapGetters('customer', [
      'customerDetail'
    ]),
    basicInfo() {
      return (this.customerDetail && this.customerDetail.basicInfo) || {} //在这里改
    },
    detailInfo() {
      return (this.customerDetail && this.customerDetail.detailInfo) || {}
    },
    linkmanInfos() {
      // if (this.customerDetail && this.customerDetail.linkmanInfos) {
      //   console.log('this.customerDetail', this.customerDetail.linkmanInfos)
      //   for (const argument of this.customerDetail.linkmanInfos) {
      //     console.log('加backup')
      //     argument.backup = ''
      //   }
      // }
      return (this.customerDetail && this.customerDetail.linkmanInfos) || []
    },
    aadhaarInfo() {
      return (this.customerDetail && this.customerDetail.aadhaarInfo) || {}
    },
    panInfo() {
      return (this.customerDetail && this.customerDetail.panInfo) || {}
    },
    imageInfos() {
      return (this.customerDetail && this.customerDetail.imageInfos) || []
    },
    bankCardInfo() {
      return (this.customerDetail && this.customerDetail.bankCardInfo) || []
    },
    orderInfo() {
      return (this.orderDetail || {}).orderInfo || {}
    },
    examineSource() {
      return this.examineLogList || []
    },
    repayRecordSource() {
      return this.repayRecordList || []
    },
    repayFlowSource() {
      return this.repayFlowList || []
    },
    collectionSource() {
      return this.allCollectionTaskList || []
    }
  },
  mounted() {
    console.log('进图了mounted！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！')
    // console.log('烦死了',this.$props)
    sessionStorage.clear()
    // console.log('换文字！！lang', lang)
    // console.log('换文字！！i18n', i18n)
    // console.log('换文字this.languageStorage -->', this.languageStorage)
    window.aa = this
    console.log('展示不展示复选框——————————————————————>', this.approvalStatus)
    if (this.approvalStatus === 2) {//2审核未通过
      console.log('走了这里')
      this.showForm = true
      this.btndisableValue = true
      this.btndisableFBValue = true
      this.btndisableEmailValue = true
    } else {
      console.log('走了这里1')
      this.showForm = false
      this.btndisableValue = false
      this.btndisableFBValue = false
      this.btndisableEmailValue = false
      this.checkedpass = true
    }

    this.requestDetail(this.orderId)
    // console.log('taskid------------>', this.taskId)

    // this.getOrderDetail(this.orderId).then(orderres => {
    //   console.log('getOrderDetail------>', orderres)
    // })

  },
  methods: {
      ...mapActions('platformCollection', [
          'getAllCollectionTaskList'
      ]),
    ...mapActions('order', [
      'getOrderDetail',
      'getExamineLogList',
      'getRepayPlanList',
      'getRepayRecordList',
      'getRepayFlowList'
    ]),
    ...mapActions('approval', [
      'auditApproval',
      'getApprovalListItem'
    ]),
    ...mapActions('customer', [
      'getCustomerDetail'
    ]),
    // //加密
    // encryptData() {
    //   console.log('调用了加密方法')
    //   const input = "17625931127";
    //   const aesKey = "f25b88c96a4538320c34b10b6107f73c"; // 替换为你的 AES 密钥
    //
    //   // 将密钥转换为 WordArray
    //   const key = CryptoJS.enc.Utf8.parse(aesKey);
    //
    //   // 使用 AES 加密模式 ECB 进行加密
    //   const encrypted = CryptoJS.AES.encrypt(input, key, {
    //     mode: CryptoJS.mode.ECB,
    //     padding: CryptoJS.pad.Pkcs7
    //   });
    //
    //   // 将加密后的内容转换为 Base64 字符串
    //   const encryptedBase64 = Base64.stringify(encrypted.ciphertext);
    //
    //   console.log("Encrypted Result:", encryptedBase64);
    //   this.decryptFun(encryptedBase64,aesKey)
    //
    // },
    repayPlanSource() {
      return this.repayPlanList || []
    },
    onTabChange(key) {
      this.currentTabTwo = key
    },
    getCreditAppData(currentphone){
      console.log('号码是多少--->>>',currentphone)
      let obj = getCreditApp({
        custMobile:currentphone
      })
      obj.then((res) => {
        if (res.code === 1000) {
          console.log('安装情况',res.data)
         this.creditappsNum=res.data.length
          // this.creditappsNum=10
        } else {
          console.log('接口未能正确返回数据',res)
        }
      }).finally(() => {
      })
    },
    sendtipsmsg() {
      console.log('this.orderId', this.orderId)
      let obj = sendsmsTips({ orderId: this.orderId })
      obj.then((res) => {
        console.log('发送提示信息resres', res)
        if (res.code === 1000) {
          this.$message.success(this.$t(I18N_KEY.ORDER + 'sendSmSSuccess'))
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
      })
    },
    addcontactPhoneNumChange(val) {
      console.log('val', val)
      console.log('hhhhhh', this.addcontactPhoneNum)
      // 数字最大长度为10
      if (this.addcontactPhoneNum.length > 10) {
        this.addcontactPhoneNum = this.addcontactPhoneNum.slice(0, 10)
      }
    },
    addcontactNameSubmit() {
      console.log('联系人名称', this.addcontactName)
      console.log('联系人电话', this.addcontactPhoneNum)
      console.log('联系人关系', this.addcontactRealtion)
      console.log('拿到id了不--->', this.custInfoId)
      //校验电话

      //添加联系人的请求
      const params = {
        custInfoId: this.custInfoId,
        contactType: 4,//手动添加联系人
        contactName: this.addcontactName,
        relationType: this.addcontactRealtion,
        contactPhone: this.addcontactPhoneNum,
        isManualAddContact: 1//手动添加联系人的标识
      }
      const paramsarr = []
      paramsarr.push(params)
      console.log('要添加联系人的参数paramsarr', paramsarr)
      if (this.custInfoId !== undefined && this.addcontactPhoneNum && this.addcontactRealtion && this.addcontactName) {
        // 校验号码
        if (this.addcontactPhoneNum.length === 10) {
          let obj = addAlternateContact(paramsarr)
          obj.then((res) => {
            if (res.code === 1000) {
              //实现一个一个添加
              this.recentcontactNum = this.recentcontactNum + 1
              //选项信息滞空
              this.addcontactName = ''
              this.addcontactPhoneNum = ''
              this.addcontactRealtion = ''
              // this.remarkValue = ''
              //刷新页面
              this.requestDetail(this.orderId)
              console.log('存储到上次值没有', this.linkmanInfos)
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
          })

        } else {
          this.$message.error(this.$t(I18N_KEY.CUSTOMER + 'contaphonterrortipsctType'))
        }

      } else {
        this.$message.error(this.$t(I18N_KEY.CUSTOMER + 'mustinput'))
      }


    },
    //添加联系人
    addcustomerLinkInfoFun() {
      console.log(' this.nestlineknum', this.nestlineknum)
      console.log('...this.linkmanInfos', ...this.linkmanInfos)
      console.log('当前有几个联系人', this.recentcontactNum)
      if (this.recentcontactNum === this.nestlineknum) {
        //下一步从写插槽开始
        const newData = {
          contactName: '',
          contactPhone: '',
          contactType: this.$t(I18N_KEY.CUSTOMER + 'appendadd'),
          relationType: '',
          backup: ''
        }
        // this.linkmanInfos = [...this.linkmanInfos, newData];
        this.linkmanInfos = this.linkmanInfos.push(newData)
        console.log('this.linkmanInfos', this.linkmanInfos)
        this.nestlineknum = this.nestlineknum + 1
      } else {
        this.$message.error(this.$t(I18N_KEY.CUSTOMER + 'adderror'))
      }
    },

    contactNameChange(val) {
      console.log('联系人姓名输入有变化啦！this.addcontactName)', this.addcontactName)
      console.log('姓名val', val)
      // console.log('姓名', val.srcElement._value);
      let newValue = this.addcontactName
      const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(newValue)) {
        console.log('输入了中文')
        newValue = newValue.replace(reg, '')
        this.$nextTick(() => {
          console.log('要用的值', newValue)
          this.addcontactName = newValue
        })
      } else {
        console.log('没有输入中文！！')
      }

    },
    handleChange(value) {
      console.log(`selected ${value}`)
    },

    // 解密方法
    decryptFun(encryptedBase64val, aesKeyval) {
      console.log('调用了解密的方法！')
      const encryptedBase64 = encryptedBase64val // 替换为你的加密后的数据
      const aesKey = aesKeyval // 替换为你的 AES 密钥

      // 将密钥转换为 WordArray
      const key = CryptoJS.enc.Utf8.parse(aesKey)

      // 将 Base64 字符串转换为 WordArray
      const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64)

      // 使用 AES 解密模式 ECB 进行解密
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        key,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      )

      // 将解密后的 WordArray 转换为字符串
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8)
      console.log('Decrypted Result:', decryptedText)
      return decryptedText
    },


    //电话备注弹框
    TextareaonRemarkChange(e) {
      console.log('电话备注栏发生变化啦！！！', e)
      console.log('电话备注栏输入的内容', e.target._value)
      // this.remarkValue += this.contactWhoType + ' ' + this.contactWhoPhone + ' ' + this.contactWhoName + ' ' + this.phoneRemarkValue
      console.log('电话备注栏输入的内容this.phoneRemarkValue--->', this.phoneRemarkValue)
    },
    TextareaonChange(e) {
      console.log('备注栏发生变化啦！！！', e)
      console.log('备注栏输入的内容', e.target._value)
      // this.remarkValue += e.target._value
      console.log('备注栏输入的内容this.remarkValue--->', this.remarkValue)
    },
    ContacthandleCancel() {
      this.ContactVisible = false
    },
    ContacthandleOk() {
      console.log('this.--->', this.showFinishImg)
      console.log('烦死了这是个啥', this.recentcontactNum)
      const lianxirenNum = this.recentcontactNum + 1 //记录当前到底有几个联系人，最后一个是本人
      // if (this.showFinishImg !== 4) {
      if (this.showFinishImg !== lianxirenNum) {
        console.log('修改联系人手机号')
        this.linkmanInfos[this.showFinishImg].backup = '已填'
        console.log('linkmanInfos--->', this.linkmanInfos)
        sessionStorage.setItem(this.orderId, JSON.stringify(this.linkmanInfos))
      } else {
        console.log('修改本人手机号')
        this.showzhudedianhua = true
      }


      console.log('电话的备注输入框有哪些内容呢', this.phoneRemarkValue)
      console.log('this.remarkValue大的备注栏', this.remarkValue)
      console.log(' this.contactWhoType', this.contactWhoType)

      if (!this.remarkValue.includes(this.ContactVisible)) {
        console.log('执行某操作', this.remarkValue)
        // const sringvalue = this.contactWhoType + ' : ' + this.contactWhoName + ' ,' + this.contactWhoPhone + ' , ' + this.phoneRemarkValue + ' ; '
        const newContact = this.contactWhoType + ' : ' + this.contactWhoName + ' ,' + this.contactWhoPhone + ' , ' + this.phoneRemarkValue + ' ; '

        // 判断是否已存在相同contactWhoType和contactWhoPhone的数据
        if (this.remarkValue.includes(this.contactWhoType) && this.remarkValue.includes(this.contactWhoPhone)) {
          // 替换原来的内容
          const regex = new RegExp(this.contactWhoType + ' : ' + this.contactWhoName + ' ,' + this.contactWhoPhone + ' , [^;]+ ; ')
          this.remarkValue = this.remarkValue.replace(regex, newContact)
        } else {
          this.remarkValue += newContact
        }
        console.log('sringvalue', newContact)
        // this.remarkValue += sringvalue

      }
      this.ContactVisible = false
    },
    openRemarkModal(typeval, nameval, phoneval, vackupval) {//		7179784921257346049
      this.remarkOptions = []//清空上次选的值
      console.log('点击了备注', '联系人类型--->', typeval, '姓名--->', nameval, '电话-->', phoneval, 'backup-->', vackupval)
      console.log('vackupval', vackupval)
      this.showFinishImg = vackupval
      if (this.languageStorage == 'ti') {
        this.contactWhoType = this.$t(ContactPerson_FLAG_TI[typeval])
      } else if (this.languageStorage == 'zh-CN') {
        this.contactWhoType = this.$t(ContactPerson_FLAG[typeval])
      } else {
        this.contactWhoType = this.$t(ContactPerson_FLAG_EN[typeval])
      }
      if (typeval >= 4) {
        this.contactWhoType = this.$t(I18N_KEY.CUSTOMER + 'handlecontactType')
      }


      // if (typeval == '本人') {
      //   console.log('选择了本人加密显示！！')
      //   this.contactWhoPhone = phoneval.replace(/(\d{3})\d{4}(\d{3})/, '$1****$2')
      // } else {
      //   console.log('没选本人不加密')
      //   this.contactWhoPhone = phoneval
      // }
      this.contactWhoPhone = phoneval


      if (typeval == '本人') {
        this.showFormContant = false
      } else {
        this.showFormContant = true
      }
      this.ContactVisible = true
      this.contactWhoName = nameval

      this.phoneRemarkValue = ''
      console.log('this.bigRemarkValue', this.bigRemarkValue)
    },
    //发送邮件
    sendEmail(val, valid) {
      const email = val
      const custId = valid
      const params = {
        email,
        custId
      }
      console.log('params', params)
      let obj = sendEmailfn(params)
      obj.then((res) => {
        if (res.code === 1000) {
          //刷新页面
          this.getCustomerDetail({ id: this.custInfoId })
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
      })
    },
    //编辑邮箱
    editEmail(val, id) {
      this.emailvalue = val
      this.emailEditID = id
      this.showEmialInput = !this.showEmialInput
      this.btndisableEmailValue = !this.btndisableEmailValue
      console.log('showEmialInput', this.showEmialInput)
    },
    validateEmail(email) {
      const pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
      return pattern.test(email)
    },
    //取消编辑邮箱
    cancelSaveEdit() {
      this.showEmialInput = !this.showEmialInput
      this.btndisableEmailValue = !this.btndisableEmailValue
    },
    //保存邮箱
    saveEdit() {
      const email = this.emailvalue
      const id = this.emailEditID
      const params = {
        email,
        id
      }
      console.log('params', params)
      if (this.validateEmail(email)) {
        let obj = editCustomer(params)
        obj.then((res) => {
          if (res.code === 1000) {
            this.$message.success('Save successfully！')
            //刷新页面
            this.requestDetail(this.orderId)
            console.log('邮箱更新成功后刷新了页面！')
            this.showEmialInput = !this.showEmialInput
            this.btndisableEmailValue = !this.btndisableEmailValue
          } else {
            this.$message.error(res.msg)
          }
        }).finally(() => {
        })
      } else {
        this.$message.error('Mailbox format error！')
      }
    },
    // line
    editLineNumber(val, id) {
      this.linevalue = val
      this.lineEditID = id
      this.showLineInput = !this.showLineInput
      this.btndisablelineValue = !this.btndisablelineValue
      console.log('showLineInput', this.showLineInput)
      console.log('btndisablelineValue', this.btndisablelineValue)
    },
    cancelSaveLineEdit() {
      this.showLineInput = !this.showLineInput
      this.btndisablelineValue = !this.btndisablelineValue
    },
    saveLineEdit() {
      const line = this.linevalue
      const id = this.lineEditID
      const params = {
        id,
        line
      }
      console.log('params', params)
      let obj = editFacebook(params)
      obj.then((res) => {
        if (res.code === 1000) {
          this.$message.success('Save successfully！')
          //刷新页面
          this.requestDetail(this.orderId)
          console.log('FaceBook更新成功后刷新了页面！')
          this.showLineInput = !this.showLineInput
          this.btndisablelineValue = !this.btndisablelineValue
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
      })

    },




    // tiktok
    edittiktokNumber(val, id) {
      this.tiktokvalue = val
      this.tiktokEditID = id
      this.showtiktokInput = !this.showtiktokInput
      this.btndisabletiktokValue = !this.btndisabletiktokValue
      console.log('showtiktokInput', this.showtiktokInput)
      console.log('btndisabletiktokValue', this.btndisabletiktokValue)
    },
    cancelSavetiktokEdit() {
      this.showtiktokInput = !this.showtiktokInput
      this.btndisabletiktokValue = !this.btndisabletiktokValue
    },
    savetiktokEdit() {
      const tiktokNumber = this.tiktokvalue
      const id = this.tiktokEditID
      const params = {
        id,
        tiktokNumber
      }
      console.log('params', params)
      let obj = editFacebook(params)
      obj.then((res) => {
        if (res.code === 1000) {
          this.$message.success('Save successfully！')
          //刷新页面
          this.requestDetail(this.orderId)
          console.log('FaceBook更新成功后刷新了页面！')
          this.showtiktokInput = !this.showtiktokInput
          this.btndisabletiktokValue = !this.btndisabletiktokValue
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
      })

    },





    // fb



    //编辑facebook
    editFBEmail(val, id) {
      this.FBvalue = val
      this.FBEditID = id
      this.showFBInput = !this.showFBInput
      this.btndisableFBValue = !this.btndisableFBValue
      console.log('showFBInput', this.showFBInput)
      console.log('btndisableFBValue', this.btndisableFBValue)
    },
    //取消编辑facebook
    cancelSaveFBEdit() {
      this.showFBInput = !this.showFBInput
      this.btndisableFBValue = !this.btndisableFBValue
    },
    //保存facebook
    saveFBEdit() {
      const fb = this.FBvalue
      const id = this.FBEditID
      const params = {
        id,
        fb
      }
      console.log('params', params)
      let obj = editFacebook(params)
      obj.then((res) => {
        if (res.code === 1000) {
          this.$message.success('Save successfully！')
          //刷新页面
          this.requestDetail(this.orderId)
          console.log('FaceBook更新成功后刷新了页面！')
          this.showFBInput = !this.showFBInput
          this.btndisableFBValue = !this.btndisableFBValue
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
      })

    },
    convertPhoneNumber(phone) {
      if (!phone) return phone;
      phone = String(phone).trim();
      const prefix = phone.substring(0, 2);
      // 如果是66开头，直接返回
      if (prefix === '66') {
        // return phone;
        return phone.substring(2);
      }
      // 如果不是66开头（一般是0开头），去掉第一位再加上66
      if (phone[0] === '0') {
        // return '66' + phone.substring(1);
        return phone.substring(1);
      }
      return phone;
    },
    copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        // 现代浏览器，安全环境（HTTPS）
        return navigator.clipboard.writeText(text)
          .then(() => {
            console.log('复制成功');
          })
          .catch(err => {
            console.error('复制失败:', err);
          });
      } else {
        // 旧浏览器兼容方案
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed'; // 防止页面滚动
        textarea.style.opacity = 0;
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          console.log('复制成功');
        } catch (err) {
          console.error('复制失败:', err);
        }
        document.body.removeChild(textarea);
      }
    },
    handlePhoneClick(phone) {
      console.log('点击的电话-->', phone)
      const phonenum = this.convertPhoneNumber(phone)
      this.copyToClipboard(phonenum)
      window.addEventListener("message", (event) => {
        // 打印接收到的数据
        console.log('烦死了', event.data.type)
        console.log('event', event);
      }, false);

      const callMessage = {
        type: 'callOut',
        message: {
          type: 'callOut',
          content: {
            caller: '', // 留空由系统选择主叫
            callee: phonenum,
            countryCode: '66',
            orderId: this.orderId,
            params: ''
          }
        }
      };
      window.postMessage(callMessage, '*');
      console.log('已发送拨打命令给插件');


      // document.addEventListener('error', function(e) {
      //   console.log('e', e)
      //   if (e.message.includes('Failed to launch')) {
      //     console.log('没安装')
      //   }
      // })
      // const salt = 3741 // 设置盐值
      // const encodedPhone = this.encode_phone(phone, salt) // 调用加密函数对电话号码进行加密处理
      // const encryptedHref = 'sip:' + encodedPhone // 拼接加密后的电话号码
      // console.log('encryptedHref-->', encryptedHref)
      // 调用拨打电话的操作
    },
    encode_phone(phone, salt) {
      console.log('加密拨打的电话号码', phone)
      let len = phone.toString().length
      let prefix = ''
      let suffix = 0
      let newPhone

      if (len > 8) {
        prefix = phone.toString().substr(0, len - 8)
        phone = phone.toString().substr(len - 8)
        suffix = 8 - parseInt(phone).toString().length
        phone = parseInt(phone)
      } else {
        phone = parseInt(phone)
        suffix = len - phone.toString().length
      }

      newPhone = (phone & 0xff000000)
      newPhone += (phone & 0x0000ff00) << 8
      newPhone += (phone & 0x00ff0000) >> 8
      newPhone += (phone & 0x0000000f) << 4
      newPhone += (phone & 0x000000f0) >> 4
      newPhone ^= salt

      return prefix + '' + newPhone + '' + suffix + '' + newPhone.toString().length
    },


    handleOk(e) {
      console.log(e)
      this.ModalVisible = false
    },
    pendingReviewFn() {
      let imageFlag = []
      for (const items of this.linkmanInfos) {
        if (items.backup == '') {
          imageFlag.push(0)
        } else {
          imageFlag.push(1)
        }
      }
      console.log('注册电话备注了吗', this.showzhudedianhua)
      if (this.showzhudedianhua == true) {
        imageFlag.push(1)
      } else {
        imageFlag.push(0)
      }

      console.log('点击了待复审！')
      console.log(' 要传给后端的数组imgFlags', imageFlag)
      console.log('this.Q_cust_image_normal', this.Q_cust_image_normal)
      console.log('this.selectedOptionsOne', this.selectedOptionsOne)
      // 证件照
      if (this.Q_cust_image_normal) {
        this.chooseItems[0].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsOne.length) {
        console.log('回显有值')
        this.chooseItems[0].itemResult = this.selectedOptionsOne
      } else {
        console.log('回显没值')
        this.chooseItems[0].itemResult = this.image_normal_array
      }

      //活动人员
      if (this.Q_cust_living_body_normal) {
        this.chooseItems[1].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsTwo.length) {
        console.log('回显有值')
        this.chooseItems[1].itemResult = this.selectedOptionsTwo
      } else {
        console.log('回显没值')
        this.chooseItems[1].itemResult = this.Q_cust_living_body_normal
      }
      //联系
      if (this.Q_cust_contactperson_normal) {
        this.chooseItems[2].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsThree.length) {
        console.log('回显有值')
        this.chooseItems[2].itemResult = this.selectedOptionsThree
      } else {
        console.log('回显没值')
        this.chooseItems[2].itemResult = this.Q_cust_contactperson_normal
      }
      //电话
      if (this.Q_contact_phone_normal) {
        this.chooseItems[3].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsFour.length) {
        console.log('回显有值')
        this.chooseItems[3].itemResult = this.selectedOptionsFour
      } else {
        console.log('回显没值')
        this.chooseItems[3].itemResult = this.Q_contact_phone_normal
      }
      //line正常吗
      if (this.Q_line_normal) {
        this.chooseItems[4].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsFive.length) {
        console.log('回显有值')
        this.chooseItems[4].itemResult = this.selectedOptionsFive
      } else {
        console.log('回显没值')
        this.chooseItems[4].itemResult = this.Q_line_normal
      }

      //敏感工作
      if (this.Q_Sensitiveoccupation_normal) {
        this.chooseItems[5].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsSix.length) {
        console.log('回显有值')
        this.chooseItems[5].itemResult = this.selectedOptionsSix
      } else {
        console.log('回显没值')
        this.chooseItems[5].itemResult = this.Q_Sensitiveoccupation_normal
      }


      //facebook正常吗
      if (this.Q_Facebook_normal) {
        this.chooseItems[6].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsSeven.length) {
        console.log('回显有值')
        this.chooseItems[6].itemResult = this.selectedOptionsSeven
      } else {
        console.log('回显没值')
        this.chooseItems[6].itemResult = this.Q_Facebook_normal
      }



      console.log('最后要传给后端的数组！！！', this.chooseItems)
      // 非空校验
      if ((this.chooseItems[0].itemResult.length !== 0 && this.chooseItems[0].itemResult !== false) &&
        (this.chooseItems[1].itemResult.length !== 0 && this.chooseItems[1].itemResult !== false) &&
        (this.chooseItems[2].itemResult.length !== 0 && this.chooseItems[2].itemResult !== false) &&
        (this.chooseItems[3].itemResult.length !== 0 && this.chooseItems[3].itemResult !== false) &&
        (this.chooseItems[4].itemResult.length !== 0 && this.chooseItems[4].itemResult !== false) &&
        (this.chooseItems[5].itemResult.length !== 0 && this.chooseItems[5].itemResult !== false) &&
        (this.chooseItems[6].itemResult.length !== 0 && this.chooseItems[6].itemResult !== false)
      ) {
        console.log('可以发请求')
        peopleExamine({
          taskId: this.taskId,
          items: this.chooseItems,
          remark: this.remarkValue,
          pendingReApprovalStatus: 1,
          imageFlag: imageFlag
        }).then((res) => {
          if (res.code === 1000) {
            this.$message.success('Submitted successfully!')
            this.$emit('closeDetail')//关闭弹窗
            this.$emit('searchQuery')//刷新页面
          }
        }).catch(e => {
          this.$message.error(e.message)
        })
      } else {
        this.ModalVisible = true
      }

    },
    submitInfo() {
      let imageFlag = []
      for (const items of this.linkmanInfos) {
        if (items.backup == '') {
          imageFlag.push(0)
        } else {
          imageFlag.push(1)
        }
      }
      console.log('注册电话备注了吗', this.showzhudedianhua)
      if (this.showzhudedianhua == true) {
        imageFlag.push(1)
      } else {
        imageFlag.push(0)
      }
      console.log('点击了提交')
      // 证件照
      if (this.Q_cust_image_normal) {
        this.chooseItems[0].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsOne.length) {
        console.log('回显有值')
        this.chooseItems[0].itemResult = this.selectedOptionsOne
      } else {
        console.log('回显没值')
        this.chooseItems[0].itemResult = this.image_normal_array
      }

      //活动人员
      if (this.Q_cust_living_body_normal) {
        this.chooseItems[1].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsTwo.length) {
        console.log('回显有值')
        this.chooseItems[1].itemResult = this.selectedOptionsTwo
      } else {
        console.log('回显没值')
        this.chooseItems[1].itemResult = this.Q_cust_living_body_normal
      }
      //联系
      if (this.Q_cust_contactperson_normal) {
        this.chooseItems[2].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsThree.length) {
        console.log('回显有值')
        this.chooseItems[2].itemResult = this.selectedOptionsThree
      } else {
        console.log('回显没值')
        this.chooseItems[2].itemResult = this.Q_cust_contactperson_normal
      }
      //电话
      if (this.Q_contact_phone_normal) {
        this.chooseItems[3].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsFour.length) {
        console.log('回显有值')
        this.chooseItems[3].itemResult = this.selectedOptionsFour
      } else {
        console.log('回显没值')
        this.chooseItems[3].itemResult = this.Q_contact_phone_normal
      }
      //LINE
      if (this.Q_line_normal) {
        this.chooseItems[4].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsFive.length) {
        console.log('回显有值')
        this.chooseItems[4].itemResult = this.selectedOptionsFive
      } else {
        console.log('回显没值')
        this.chooseItems[4].itemResult = this.Q_line_normal
      }
      //敏感职业
      if (this.Q_Sensitiveoccupation_normal) {
        this.chooseItems[5].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsSix.length) {
        console.log('回显有值')
        this.chooseItems[5].itemResult = this.selectedOptionsSix
      } else {
        console.log('回显没值')
        this.chooseItems[5].itemResult = this.Q_Sensitiveoccupation_normal
      }
      //facebook正常吗
      if (this.Q_Facebook_normal) {
        this.chooseItems[6].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsSeven.length) {
        console.log('回显有值')
        this.chooseItems[6].itemResult = this.selectedOptionsSeven
      } else {
        console.log('回显没值')
        this.chooseItems[6].itemResult = this.Q_Facebook_normal
      }

      console.log('最后要传给后端的数组！！！', this.chooseItems)
      // 非空校验
      if ((this.chooseItems[0].itemResult.length !== 0 && this.chooseItems[0].itemResult !== false) &&
        (this.chooseItems[1].itemResult.length !== 0 && this.chooseItems[1].itemResult !== false) &&
        (this.chooseItems[2].itemResult.length !== 0 && this.chooseItems[2].itemResult !== false) &&
        (this.chooseItems[3].itemResult.length !== 0 && this.chooseItems[3].itemResult !== false) &&
        (this.chooseItems[4].itemResult.length !== 0 && this.chooseItems[4].itemResult !== false) &&
        (this.chooseItems[5].itemResult.length !== 0 && this.chooseItems[5].itemResult !== false) &&
        (this.chooseItems[6].itemResult.length !== 0 && this.chooseItems[6].itemResult !== false)
      ) {
        console.log('可以发请求')
        console.log('chooseItems',this.chooseItems)
        console.log('remarkValue',this.remarkValue)
        peopleExamine({
          taskId: this.taskId,
          items: this.chooseItems,
          remark: this.remarkValue,
          pendingReApprovalStatus: 0,
          imageFlag: imageFlag
        }).then((res) => {//	7197156611150840833
          if (res.code === 1000) {
            this.$message.success('Submitted successfully!')
            this.$emit('closeDetail')//关闭弹窗
            this.$emit('searchQuery')//刷新页面
          }
        }).catch(e => {
          this.$message.error(e.message)
        })
      } else {
        this.ModalVisible = true
      }

    },
    radioOneChange(e) {
      console.log('e打印出来是什么ne', e)//可以拿到正常的下标0
      console.log('可以拿到正的下标吗？', e.target.value)//可以拿到正常的下标0
      this.Q_cust_image_normal = !this.Q_cust_image_normal
    },
    radioTwoChange(e) {
      console.log('e打印出来是什么ne', e)//可以拿到正常的下标0
      console.log('可以拿到正的下标吗？', e.target.value)//可以拿到正常的下标0
      this.Q_cust_living_body_normal = !this.Q_cust_living_body_normal
    },
    radioThreeChange(e) {
      this.Q_cust_contactperson_normal = !this.Q_cust_contactperson_normal
    },
    radioFourChange(e) {
      this.Q_contact_phone_normal = !this.Q_contact_phone_normal
    },
    radiFiveChange(e) {
      this.Q_line_normal = !this.Q_line_normal
    },
    radiSixChange(e) {
      this.Q_Sensitiveoccupation_normal = !this.Q_Sensitiveoccupation_normal
    },
    radiSevenChange(e) {
      this.Q_Facebook_normal = !this.Q_Facebook_normal
    },
    // normremarkCheckedFn(e) {
    //   console.log('e')
    //   this.normremarkChecked = !this.normremarkChecked
    // },
    CheckBoxOnChangeOne(checkedValues) {
      console.log('checked = ', checkedValues)
      this.image_normal_array = checkedValues
      this.childValueOne = checkedValues
      console.log('非正常情况多选的数组结果', this.image_normal_array)
    },
    CheckBoxOnChangeTwo(checkedValues) {
      this.living_body_normal_array = checkedValues
      this.childValueTwo = checkedValues
    },
    CheckBoxOnChangeThree(checkedValues) {
      this.contactperson_normal_array = checkedValues
      this.childValueThree = checkedValues
    },
    CheckBoxOnChangeFour(checkedValues) {
      this.ontact_phone_array = checkedValues
      this.childValueFour = checkedValues
    },
    CheckBoxOnChangeFive(checkedValues) {
      this.line_normal_array = checkedValues
      this.childValueFive = checkedValues
    },
    CheckBoxOnChangeSix(checkedValues) {
      this.Sensitive_occupation_array = checkedValues
      this.childValueSix = checkedValues
    },
    CheckBoxOnChangeSeven(checkedValues) {
      this.Facebook_normal_array = checkedValues
      this.childValueSeven = checkedValues
    },
    rmarkboxChange(val) {
      console.log('发生变化啦', val)
      const str = val.join(',')
      console.log('回显的勾选项', str)
      this.phoneRemarkValue = str
    },
    drawContainer() {
      return document.querySelector('.ant-modal-wrap')
    },
    handelDrawer(visible) {
      if (visible) {
        this.openDrawerCount++
        this.openDrawer()
        this.openDrawerCount < 2 && this.$nextTick(() => {
          this.basicForm.setFieldsValue(this.listItem)
        })
      } else {
        this.closeDrawer()
      }
    },
    openDrawer() {
      this.visible = true
    },
    closeDrawer() {
      this.visible = false
      // this.basicForm.resetFields();
    },
    submitAuditForm(status) {
      this.basicForm.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          const { remark } = values
          delete values.remark
          const items = Object.entries(values).map(item => {
            return {
              itemCode: item[0],
              itemResult: item[1]
            }
          })
          const data = {
            taskId: this.taskId,
            remark,
            items
          }
          this.auditApproval(data).then(res => {
            this.$message.success(this.$t('success'))
            this.closeParentModal()
          }).catch(e => {
            this.$message.error(e.message)
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    closeParentModal() {
      this.$emit('close')
    },
    requestDetail(id) {
      // 先执行不需要等待的同步接口（这些接口不影响Promise.all的逻辑）
      this.getRepayPlanList({ orderId: id });
      this.getExamineLogList({ orderId: id });
      this.getRepayRecordList({ orderId: id });
      this.getRepayFlowList({ orderId: id });
      this.getAllCollectionTaskList({ orderId: id });

      // 打印mobileNo（移到Promise.all外，避免作为数组元素）
      console.log("phoneprops:-------------" + this.phoneprops);

      // 定义需要传入Promise.all的Promise数组
      const promises = [
        // 第一个固定Promise
        getPlatformAllOrderList({ "custInfoId": this.custInfoId, "flag": 1 })
            .then((res) => {
              if (res.code === 1000) {
                this.historicalOrdersSource = res.data.rows;
              } else {
                this.historicalOrdersSource = [];
                this.$message.error(res.msg);
              }
            })
            .catch(e => {
              this.$message.error(e.message);
            }),
        //btc征信
          //  getBtcVerify({ custInfoId: this.custInfoId})
          // .then((res) => {
          //   if (res.code === 1000) {
          //     this.BtcVerifySource = res.data;
          //   } else {
          //     this.BtcVerifySource = [];
          //     this.$message.error(res.msg);
          //   }
          // })
          // .catch(e => {
          //   this.$message.error(e.message);
          // }),

        //同盾征信
          // getDetectVerify({ custInfoId: this.custInfoId})
          //   .then((res) => {
          //     if (res.code === 1000) {
          //       this.detectVerifySource = res.data;
          //     } else {
          //       this.detectVerifySource = [];
          //       this.$message.error(res.msg);
          //     }
          //   })
          //   .catch(e => {
          //     this.$message.error(e.message);
          //   }),

        // 订单详情Promise
        this.getOrderDetail({ id }).then(orderres => {
          console.log('orderres-->isShowContacts', orderres);
        }),

        // 客户详情Promise
        this.getCustomerDetail({ id: this.custInfoId }).then(res => {
          console.log('Customer Detail---》:', res.data);
          if (res.data.collectionCallRecordInfos) {
            this.calllistDataScorce = res.data.collectionCallRecordInfos;
          }
          const jiemidata = res.data.basicInfo;
          console.log('号码', jiemidata.mobileNo);
          this.getCreditAppData(jiemidata.mobileNo);

          this.linkmanInfos = res.data.linkmanInfos;
          for (const argument of this.linkmanInfos) {
            this.$set(argument, 'backup', '');
          }
          console.log('this.linkmanInfos====================', this.linkmanInfos);
          this.nestlineknum = res.data.linkmanInfos.length;
          this.recentcontactNum = res.data.linkmanInfos.length;
          return res.data.basicInfo;
        })
      ];
      console.log("phoneprops:烦死了" + this.phoneprops)
      // 条件性添加Promise（仅当mobileNo有效时）
      if (this.phoneprops != null && this.phoneprops !== undefined) { // 修正为&&，排除null和undefined
        // 添加getAllOrderListSummary的Promise
        promises.push(
            getAllOrderListSummary({ "mobileNo": this.phoneprops })
                .then((res) => {
                  if (res.code === 1000) {
                    this.orderSummary = res.data;
                    this.jointBondOrderSource = res.data.rows;
                  } else {
                    this.jointBondOrderSource = [];
                    this.$message.error(res.msg);
                  }
                })
                .catch(e => {
                  this.$message.error(e.message);
                })
        );

        // 添加getCreditApp的Promise
        promises.push(
            getCreditApp({ custMobile: this.phoneprops })
                .then((res) => {
                  if (res.code === 1000) {
                    if (res.data) {
                      this.addressBookSize = res.data.length;
                      console.log("res.data.length" + res.data.length);
                      this.addressBookData = res.data;
                    }
                  } else {
                    console.log('接口异常', res);
                  }
                })
                .catch(e => {
                  console.log('调用通讯录接口异常', e.message);
                })
        );
      }

      // 执行所有Promise
      Promise.all(promises)
          .then(res => {
            this.loading = false;
            this.getApprovalListItem({ taskId: this.taskId }).then(res => {
              // 原逻辑保持不变...
              const { remark, items } = (res && res.data) || {};
              const form = (items || []).reduce((obj, item) => {
                obj[item.itemCode] = item.itemResult;
                return obj;
              }, {});
              this.listItem = { remark, ...form };
              if (res.data.remark) {
                this.remarkValue = res.data.remark;
              }

              const localARR = JSON.parse(sessionStorage.getItem(this.orderId));
              if (localARR) {
                console.log('localARR--------------------->', localARR);
                const resultlocalARR = localARR.map(item => item.backup.trim() === '已填' ? 1 : 0);
                for (let i = 0; i < resultlocalARR.length; i++) {
                  this.$set(this.linkmanInfos[i], 'backup', resultlocalARR[i] == 1 ? '已填' : '');
                }
              } else {
                if (res.data.items.length) {
                  // 原回显逻辑保持不变...
                  const EchoData = res.data.items;
                  console.log('拿到要回显的数据了吗', EchoData);
                  const imgEchoData = JSON.parse(res.data.items[0].backup);
                  console.log('拿到勾选回显了吗？', imgEchoData);
                  if (imgEchoData[imgEchoData.length - 1] == 1) {
                    this.showzhudedianhua = true;
                  } else {
                    this.showzhudedianhua = false;
                  }
                  let newArr = imgEchoData.slice(0, imgEchoData.length);
                  console.log('newArr-----》', newArr.length);
                  console.log('this.linkmanInfos---》', this.linkmanInfos.length);
                  for (let i = 0; i < newArr.length; i++) {
                    if (this.linkmanInfos[i] != undefined) {
                      console.log('newArr[i]', newArr[i], '是第几个元素---》', i);
                      let source1 = {
                        backup: newArr[i] == 1 ? '已填' : ''
                      };
                      Object.assign(this.linkmanInfos[i], source1);
                      console.log('this.linkmanInfos', this.linkmanInfos);
                    }
                  }

                  console.log('EchoData-------->', EchoData);
                  for (let i = 0; i < EchoData.length; i++) {
                    if (EchoData[i].itemCode == 'Q_cust_image_normal') {
                      console.log('---------->', 1);
                      this.selectedOptionsOne.push(EchoData[i].itemResult);
                    }
                    if (EchoData[i].itemCode == 'Q_cust_living_body_normal') {
                      console.log('---------->', 2);
                      this.selectedOptionsTwo.push(EchoData[i].itemResult);
                    }
                    if (EchoData[i].itemCode == 'Q_cust_contactperson_normal') {
                      console.log('---------->', 3);
                      this.selectedOptionsThree.push(EchoData[i].itemResult);
                    }
                    if (EchoData[i].itemCode == 'Q_contact_phone_normal') {
                      console.log('---------->', 4);
                      this.selectedOptionsFour.push(EchoData[i].itemResult);
                    }
                    if (EchoData[i].itemCode == 'Q_line_normal') {
                      console.log('---------->', 5);
                      this.selectedOptionsFive.push(EchoData[i].itemResult);
                    }
                    if (EchoData[i].itemCode == 'Q_Sensitiveoccupation_normal') {
                      console.log('---------->', 6);
                      this.selectedOptionsSix.push(EchoData[i].itemResult);
                    }
                    if (EchoData[i].itemCode == 'Q_Facebook_normal') {
                      console.log('---------->', 6);
                      this.selectedOptionsSeven.push(EchoData[i].itemResult);
                    }
                  }
                  this.selectedOptionsOne = this.selectedOptionsOne[0].split(',');
                  this.selectedOptionsTwo = this.selectedOptionsTwo[0].split(',');
                  this.selectedOptionsThree = this.selectedOptionsThree[0].split(',');
                  this.selectedOptionsFour = this.selectedOptionsFour[0].split(',');
                  this.selectedOptionsFive = this.selectedOptionsFive[0].split(',');
                  this.selectedOptionsSix = this.selectedOptionsSix[0].split(',');
                  this.selectedOptionsSeven = this.selectedOptionsSeven[0].split(',');

                  if (this.selectedOptionsOne[0] == '0') {
                    console.log(1111111111111111111111111111111111);
                    this.$nextTick(() => {
                      this.normOne = true;
                      this.disable0ne = true;
                    });
                    this.Q_cust_image_normal = true;
                    this.selectedOptionsOne = [];
                    if (this.Q_cust_image_normal) {
                      console.log(11111111111);
                      this.chooseItems[0].itemResult = [0];
                    } else {
                      console.log(222222222);
                      this.chooseItems[0].itemResult = this.image_normal_array;
                    }
                  } else {
                    this.normOne = false;
                  }
                  if (this.selectedOptionsTwo[0] == '0') {
                    this.$nextTick(() => {
                      this.normTwo = true;
                      this.disableTwo = true;
                    });
                    this.Q_cust_living_body_normal = true;
                    this.chooseItems[1].itemResult = this.Q_cust_living_body_normal;
                    this.selectedOptionsTwo = [];
                    if (this.Q_cust_living_body_normal) {
                      this.chooseItems[1].itemResult = [0];
                    } else {
                      this.chooseItems[1].itemResult = this.living_body_normal_array;
                    }
                  } else {
                    this.normTwo = false;
                  }
                  if (this.selectedOptionsThree[0] == '0') {
                    this.$nextTick(() => {
                      this.normThree = true;
                      this.disableThree = true;
                    });
                    this.Q_cust_contactperson_normal = true;
                    this.chooseItems[2].itemResult = this.Q_cust_contactperson_normal;
                    this.selectedOptionsThree = [];
                    if (this.Q_cust_contactperson_normal) {
                      this.chooseItems[2].itemResult = [0];
                    } else {
                      this.chooseItems[2].itemResult = this.contactperson_normal_array;
                    }
                  } else {
                    this.normThree = false;
                  }
                  if (this.selectedOptionsFour[0] == '0') {
                    this.$nextTick(() => {
                      this.normFour = true;
                      this.disableFour = true;
                    });
                    this.Q_contact_phone_normal = true;
                    this.chooseItems[3].itemResult = this.Q_contact_phone_normal;
                    this.selectedOptionsFour = [];
                    if (this.Q_contact_phone_normal) {
                      this.chooseItems[3].itemResult = [0];
                    } else {
                      this.chooseItems[3].itemResult = this.ontact_phone_array;
                    }
                  } else {
                    this.normFour = false;
                  }
                  if (this.selectedOptionsFive[0] == '0') {
                    this.$nextTick(() => {
                      this.normFive = true;
                      this.disableFive = true;
                    });
                    this.Q_line_normal = true;
                    this.chooseItems[4].itemResult = this.Q_line_normal;
                    this.selectedOptionsFive = [];
                    if (this.Q_line_normal) {
                      this.chooseItems[4].itemResult = [0];
                    } else {
                      this.chooseItems[4].itemResult = this.line_normal_array;
                    }
                  } else {
                    this.normFive = false;
                  }
                  if (this.selectedOptionsSix[0] == '0') {
                    this.$nextTick(() => {
                      this.normSix = true;
                      this.disableSix = true;
                    });
                    this.Q_Sensitiveoccupation_normal = true;
                    this.chooseItems[5].itemResult = this.Q_Sensitiveoccupation_normal;
                    this.selectedOptionsSix = [];
                    if (this.Q_Sensitiveoccupation_normal) {
                      this.chooseItems[5].itemResult = [0];
                    } else {
                      this.chooseItems[5].itemResult = this.Sensitive_occupation_array;
                    }
                  } else {
                    this.normSix = false;
                  }
                  if (this.selectedOptionsSeven[0] == '0') {
                    this.$nextTick(() => {
                      this.normSeven = true;
                      this.disableSeven = true;
                    });
                    this.Q_Facebook_normal = true;
                    this.chooseItems[6].itemResult = this.Q_Facebook_normal;
                    this.selectedOptionsSeven = [];
                    if (this.Q_Facebook_normal) {
                      this.chooseItems[6].itemResult = [0];
                    } else {
                      this.chooseItems[6].itemResult = this.Facebook_normal_array;
                    }
                  } else {
                    this.normSeven = false;
                  }
                } else {
                  this.normOne = false;
                  this.normTwo = false;
                  this.normThree = false;
                  this.normFour = false;
                  this.normFive = false;
                  this.normSix = false;
                  this.normSeven = false;
                }
              }
            });
          })
          .catch(e => {
            this.$message.error(e.message);
            this.loading = false;
          });
    }
 },
  watch: {
    // 监听 phoneprops 的变化
    phoneprops(newVal, oldVal) {
      if (newVal !== null && newVal !== undefined) {
        console.log('phoneprops 有值了:', newVal);
        // 在这里执行需要依赖 phoneprops 的逻辑（替代原来在 mounted 中写的逻辑）
      }
    },
    Q_cust_image_normal: {
      handler(newValue, oldValue) { //这里的第一个参数是改变后的值，第二个参数是原来的值
        console.log('当前的子选项值', this.image_normal_array)
        console.log('Q_cust_image_normal改后的值是：' + newValue)
        console.log('Q_cust_image_normal原来的值是：' + oldValue)
        if (newValue) {//如果被选中 多选条件被清空
          console.log('选中了正常')
          this.image_normal_array = []
          this.disable0ne = true//选了正常 禁用多选
        } else if (!newValue) {
          console.log('没选正常')
          this.disable0ne = false
          console.log('childValueOne', this.childValueOne)
          this.image_normal_array = this.childValueOne
          console.log('不禁用啦！', this.image_normal_array)
        }
      }
    },
    Q_cust_living_body_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.living_body_normal_array = []
          this.disableTwo = true
        } else if (!newValue) {
          this.disableTwo = false
          this.living_body_normal_array = this.childValueTwo
        }
      }
    },
    Q_cust_contactperson_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.contactperson_normal_array = []
          this.disableThree = true
        } else if (!newValue) {
          this.disableThree = false
          this.contactperson_normal_array = this.childValueThree
        }
      }
    },
    Q_contact_phone_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.ontact_phone_array = []
          this.disableFour = true
        } else if (!newValue) {
          this.disableFour = false
          this.ontact_phone_array = this.childValueFour
        }
      }
    },
    Q_line_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.line_normal_array = []
          this.disableFive = true
        } else if (!newValue) {
          this.disableFive = false
          this.line_normal_array = this.childValueFive
        }
      }
    },
    Q_Sensitiveoccupation_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.Sensitive_occupation_array = []
          this.disableSix = true
        } else if (!newValue) {
          this.disableSix = false
          this.Sensitive_occupation_array = this.childValueSix
        }
      }
    },
    Q_Facebook_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.Facebook_normal_array = []
          this.disableSeven = true
        } else if (!newValue) {
          this.disableSeven = false
          this.Facebook_normal_array = this.childValueSeven
        }
      }
    },

//联系人电话
    addcontactPhoneNum(newValue, oldValue) {
      // console.log('newValue', newValue);
      // console.log('oldValue', oldValue);
      if (newValue.length) {
        // console.log('进入了判断', typeof(newValue));
        if (newValue.charAt(0) == '0') {
          // console.log('输入了0');
        } else {
          // console.log('输入了非0');
          this.addcontactPhoneNum = '0' + this.addcontactPhoneNum
        }
      }
    }
  }

}
</script>
<style lang='less' scoped>
.chose-one {
  .chose-one-item {
    height: 40px;
    font-weight: bold;
  }
}

.ant-checkbox-wrapper {
  height: 40px;
}

.ant-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

//.ant-col {
//  height: 40px;
//  margin-right: 10px;
//}

.tag {
  border-style: dashed;
  background: #fff;
}

.title {
  font-size: 14px;
  color: rgba(0, 0, 0, .65);
  font-weight: 400;
  margin-bottom: 12px;
}

.file-box {
  float: left;
  width: 250px;
  height: 250px;
  margin-right: 10px;
  margin: 0 8px 8px 0;

  .file-item {
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    text-align: center;

    .file-preview {
      padding: 8px;
      width: 192px;
      height: 174px;
      margin-top: 16px;
    }

    .file-label {
      margin: 0;
      text-align: center;
      border-bottom: 1px solid #d9d9d9;
      padding: 8px;
      font-weight: 500;
      font-size: 16px;
    }
  }
}

.setting-drawer-handle {
  position: fixed;
  top: 240px;
  background: #1890ff;
  width: 32px;
  height: 32px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1301;
  text-align: center;
  font-size: 16px;
  border-radius: 4px 0 0 4px;
  transition: transform 0.3s cubic-bezier(0.9, 0, 0.3, 0.7);

  &.active {
    transform: translateX(-600px);
    // right: 500px;
  }

  i {
    color: rgb(255, 255, 255);
    font-size: 20px;
  }
}

.audit-form {
  width: 100%;
  padding: 10px;
  border: 1px solid #e9e9e9;
  background: #fff;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}

/deep/ .description-list .content {
  font-weight: 700;
}
.td-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* ✅ 强制两边列宽统一 */
}

.td-table td {
  border: 1px solid #eee;
  padding: 6px 8px;
  word-break: break-all;
}
.btc-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* ✅ 让列宽统一 */
}
.btc-table td {
  border: 1px solid #eee;
  padding: 6px 8px;
  word-break: break-all;
}
</style>